<template>

  <div v-if="!order || !order.id || !order.details" class="text-center p-5">
    <b-spinner variant="primary" label="Laster ordre..."></b-spinner>
    <p class="mt-3">Laster ordre...</p>
  </div>

  <div v-else>

    <b-row>
      <b-col md="5">
        <div class="text-left">
          <div class="mb-1">
          <b-badge pill v-if="order.status == 'Bestilling'" variant="secondary">{{ order.status }} </b-badge>
          <b-badge pill v-if="order.status == 'Ordre'" variant="primary">{{ order.status }}</b-badge>
          <b-badge pill v-if="order.status == 'I arbeid'" variant="dark">{{ order.status }}  </b-badge>
          <b-badge pill v-if="order.status == 'Arbeid avsluttet'" variant="warning">{{ order.status }}</b-badge>
          <b-badge pill v-if="order.status == 'Til fakturering'" variant="info">{{ order.status }}</b-badge>
          <b-badge pill v-if="order.status == 'Fakturert'" variant="success">{{ order.status }}</b-badge>
          <b-badge pill v-if="order.status == 'Kansellert'" variant="danger">{{ order.status }}</b-badge>
          </div>

          <h4 class="font-weight-bold ml-1">
            {{ order.ordernumber }} - {{ order.customer_company?.name || 'Ukjent kunde' }}
            <span v-if="order.site && order.site.name">{{ '(' + order.site.name + ')' }}</span>
          </h4>
        </div>
      </b-col>

      <b-col md="7">
        <div class="text-right mt-1 mb-3">

          <b-row class="float-right mr-1">
            <b-form-checkbox  v-if="user && user.role && user.role.id == '600fe2dc0b7e124b5c5f7f3b'" class="mt-2 mr-3" v-model="order.send_confirmation">
              Send ordrebekreftelse
            </b-form-checkbox>

            
            <div class="mr-3 d-md-none d-xl-block" v-if="user && user.role && user.role.id != '600fe2dc0b7e124b5c5f7f3b'">

              <b-form-select v-model="order.status" :options="orderStatus"
                placeholder="status">
              </b-form-select>
              
            </div>

            <div class="mr-3 d-md-none d-xl-block" v-if="user && user.role && user.role.id == '600fe2dc0b7e124b5c5f7f3b'">

              <b-form-select   v-model="order.status" :options="orderStatusAdmin"
                placeholder="status">
              </b-form-select>
                
            </div>

            <b-button class="mr-2" variant="default" @click="goBack()">Tilbake</b-button>

            <b-dropdown right split variant="primary" text="Lagre" @click="saveOrder()">
              <!-- <b-dropdown-item @click="openModalArchive()">Arkiver ordre</b-dropdown-item> -->
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="openModalData()">Vis ordre data</b-dropdown-item>
            </b-dropdown>

          </b-row>

        </div>
      </b-col>
    </b-row>

    <b-alert
      v-if="offlineOrderUnavailable"
      show
      variant="danger"
      class="mt-3"
    >
      Ingen lokal kopi av denne ordren er tilgjengelig offline. Koble til nett for å hente data.
    </b-alert>

    <!-- Show archive modal -->

    <b-modal id="archiveModal" title="Arkiver ordre">
      Er du sikker at du ønsker å arkivere denne ordren?


      <template #modal-footer>
        <div class="w-100">

          <b-button variant="primary" class="float-right mr-2" @click="archiveOrder()">
            Arkiver
          </b-button>

          <b-button variant="default" class="float-right mr-2" @click="closeModalArchive()">
            Lukk
          </b-button>
        </div>
      </template>

    </b-modal>

    <!-- Show data modal -->

    <b-modal id="dataModal" title="Ordre data" size="xl">

      <vue-json-pretty :data="order"></vue-json-pretty>

      <template #modal-footer>
        <div class="w-100">

          <b-button variant="primary" class="float-right mr-2" @click="closeModalData()">
            Lukk
          </b-button>
        </div>
      </template>

    </b-modal>

    <!-- Main order window -->

    <b-row>

      <b-col class="col-12 col-sm-12 col-md-12 col-lg-12">
        <div>
        </div>
          <b-card no-body>
            <b-tabs card>
              <b-tab title="Ordre" active>
                <b-card-text>

                  <!-- Debug: Connection Status -->
  

                  <b-alert
                    v-if="!$isOnline"
                    show
                    variant="danger"
                    class="mb-3"
                  >
                    NB! Du er ikke tilkoblet nett. Nye FLS lagres som utkast til du er online igjen.
                    <div class="mt-2">
                      <b-button
                        size="sm"
                        variant="outline-light"
                        @click="openOfflineEditor"
                      >
                        Åpne offline editor
                      </b-button>
                    </div>
                  </b-alert>
                  <b-alert
                    v-if="$isOnline && hasOfflineFlsDrafts"
                    show
                    variant="success"
                    class="mb-3"
                  >
                    <h6 class="alert-heading">Klar til å laste opp FLS-utkast</h6>
                    <p class="mb-2">Du har lagrede utkast som kan lastes opp til systemet.</p>
                    <b-button
                      variant="outline-success"
                      class="mr-2"
                      size="sm"
                      :disabled="isUploadingOfflineFls"
                      @click="uploadOfflineFlsDrafts"
                    >
                      Last opp
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      :disabled="isUploadingOfflineFls"
                      @click="clearOfflineFlsDrafts"
                    >
                      Fjern utkast
                    </b-button>
                  </b-alert>
                  <b-alert
                    v-if="offlineFlsError"
                    show
                    variant="danger"
                    class="mb-3"
                  >
                    {{ offlineFlsError }}
                  </b-alert>

                  <b-row>
                    <b-col md="3">

                      <!-- Edit order details   -->

                      <b-card bg-variant="light">

                        <h6>Ordre</h6>

                          <div v-if="user && user.role && user.role.id == '600fe2dc0b7e124b5c5f7f3b'">
                          Kunde:
                          <vue-typeahead-bootstrap class="mr-3 mb-3" v-model="queryCompany" :ieCloseFix="false"
                            :data="companies" :serializer="(item) => item.name" @hit="order.customer_company = $event"
                            placeholder="Søk selskap" @input="lookupCompanies" />

                          Type:
                          <b-form-select class="mr-3 mb-3" v-model="order.type" :options="orderType" placeholder="Type">
                          </b-form-select>

                          <div v-if="order.type != 'Brønnbåt'">
                            
                            Lokasjon:
                          <vue-typeahead-bootstrap class="mr-3 mb-3" v-model="querySites" :ieCloseFix="false"
                            :data="sites" :serializer="(item) => item.number + ' - ' + item.name"
                            @hit="order.site = $event" placeholder="Søk lokaliteter" @input="lookupSites" />

                          </div>

                        <div v-if="order.type == 'Brønnbåt'">

                          <b-form-group v-if="order.type == 'Brønnbåt'" class="mr-3 mb-3" label="Transport type">
                            <b-form-select class="mr-3" v-model="order.details.transport" :options="wellboatTransport">
                            </b-form-select>
                          </b-form-group>

                          <b-form-group  v-if="order.type == 'Brønnbåt'" class="mr-3 mb-3" label="Fra lokasjon">
                            <vue-typeahead-bootstrap v-model="querySites" :ieCloseFix="false" :data="sites"
                              :serializer="(item) => item.number + ' - ' + order.site.name" @hit="site = $event"
                              placeholder="" @input="lookupSites" />
                          </b-form-group>

                            <b-form-group v-if="order.type == 'Brønnbåt' && order.details.transport == 'to_location'" class="mr-3 mb-3" label="Til lokasjon">
                              <vue-typeahead-bootstrap v-model="querySitesTransport" :ieCloseFix="false" :data="sites"
                                :serializer="(item) => item.number + ' - ' + item.name" @hit="order.details.destination = $event"
                                @input="lookupSitesTransport" />
                            </b-form-group>
                  
                            <b-form-group v-if="order.type == 'Brønnbåt' && order.details.transport == 'to_factory'" class="mr-3 mb-3" label="Til fabrikk">
                              <vue-typeahead-bootstrap v-model="queryFactories" :data="factories" :serializer="
                          (item) =>
                            item.name + ' (' + item.approval + ')'
                        " @hit="order.details.destination = $event" @input="lookupFactories" />
                            </b-form-group>
                            
                          </div>
  

                        <div>
                          Startdato:
                          <datepicker class="mr-3 mb-3" v-model="order.startdate" :format="customFormatter"
                            :bootstrap-styling="true"></datepicker>
                          
                          Sluttdato:
                          <datepicker class="mr-3 mb-3" v-model="order.enddate" :format="customFormatter"
                            :bootstrap-styling="true"></datepicker>
                          
                          Fartøy:
                          <b-form-select class="mr-3 mb-3" v-model="vessel" :options="vesselSelect"></b-form-select>
                          
                          Kaptein:
                          <div v-if="crewFromPlanner" class="mr-3 mb-3 p-2 border rounded bg-light">
                            <div>{{ (order.captain && order.captain.name) || 'Ingen skipper' }}</div>
                            <small class="text-muted">
                              Mannskap fra
                              <b-link to="/dashboard/mannskapsplan">Mannskapsplanleggeren</b-link>
                              <span v-if="order.skift && order.skift.name"> ({{ order.skift.name }})</span>.
                              <b-link class="ml-1" @click="order.crew_locked = true; $forceUpdate()">Overstyr manuelt</b-link>
                            </small>
                          </div>
                          <template v-else>
                            <b-form-select class="mr-3 mb-3" v-model="captain" :options="captainSelect"></b-form-select>
                            <small v-if="order.skift && order.crew_locked" class="d-block text-muted mt-n2 mb-3">
                              Mannskapet er låst og oppdateres ikke av Mannskapsplanleggeren.
                              <b-link @click="order.crew_locked = false; $forceUpdate()">Følg planen igjen</b-link>
                            </small>
                          </template>
                          
                          Status:
                          <b-form-select  class="mr-3 mb-3" v-model="order.status" :options="orderStatusAdmin"
                            placeholder="status">
                          </b-form-select>
                          
                        </div>


                       <div v-if="user && user.role && user.role.id != '600fe2dc0b7e124b5c5f7f3b'">

                          Status:
                          <b-form-select  class="mr-3 mb-3" v-model="order.status" :options="orderStatus"
                            placeholder="status">
                          </b-form-select>
                          
                        </div>

                          <b-button class="mt-1" variant="primary" @click="updateOrder()">Lagre</b-button>

                        </div>



                      </b-card>

                    </b-col>

                    <b-col md="9">

                      <!-- Customer and contact details -->


                      <!-- Map Delousing -->
                      <div class="mb-3" v-if="order.site != null && order.type == 'Avlusning'">
                        <l-map ref="map" :zoom="4" v-bind:center="[order.site.lat, order.site.lng]"
                          style="height: 350px">
                          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                          <l-circle :lat-lng="[order.site.lat, order.site.lng]" :color="circle.color"
                            :radius="circle.radius">

                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              {{ order.site.number }} -
                              {{ order.site.name }}
                            </l-tooltip>
                          </l-circle>

                          <l-circle v-if="order.vessel != null" :lat-lng="[order.vessel.lat, order.vessel.lng]"
                            :color="circleVessel.color" :radius="circleVessel.radius">
                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              {{ order.vessel.name}}

                            </l-tooltip>
                          </l-circle>
                        </l-map>
                      </div>

                      <!-- Map Wellboat -->

                      <div class="mb-3"
                        v-if="order.details && order.details.destination != null && order.site != null && order.type == 'Brønnbåt'">

                        <l-map ref="map" :zoom="4"
                          v-bind:center="[order.details.destination.lat, order.details.destination.lng]"
                          style="height: 350px">
                          <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                          <l-circle :lat-lng="[order.site.lat, order.site.lng]" :color="circle.color"
                            :radius="circle.radius">

                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              <span>Fra lokasjon: <br> {{ order.site.number }} - {{ order.site.name }}</span>

                            </l-tooltip>


                          </l-circle>


                          <l-circle :lat-lng="[order.details.destination.lat, order.details.destination.lng]"
                            :color="circle.color" :radius="circle.radius">

                            <l-tooltip :options="{ permanent: true, interactive: true }">
                              <span v-if="order.details.transport == 'to_location'">Til lokasjon: <br>
                                {{ order.details.destination.number }} -
                                {{ order.details.destination.name }}</span>
                              <span v-if="order.details.transport == 'to_factory'">Til slakteri: <br>
                                {{ order.details.destination.approval }} -
                                {{ order.details.destination.name }}</span>
                            </l-tooltip>


                          </l-circle>


                        </l-map>

                      </div>



                      <b-card-group columns>
                        <b-card class="mb-3">
                          <h6>Bestiller</h6>

                          Kundenavn:
                          <p>
                            {{ order.customer_company?.name || 'Ukjent kunde' }}
                            <br />
                            <small class="mt-1">
                              <b-link v-b-toggle.viewCustomerDetails class="card-link">Vis detaljer</b-link>
                            </small>
                            <br />
                          </p>

                          <div v-if="showContacts == false">
                            Kontaktperson:
                            <p v-if="order.contact_name != null">
                              {{ order.contact_name }}
                              <br>
                              <small>
                                <b-link v-if="showContacts == false" @click="editContact()" class="card-link">Endre
                                  kontaktperson</b-link>
                                <br />

                              </small>

                            </p>
                            <p v-if="order.contact_name == null" style="color: red">
                              Ingen
                              <br>
                              <small>
                                <b-link v-if="showContacts == false" @click="editContact()" class="card-link">Endre
                                  kontaktperson</b-link>

                              </small>
                              <br />
                            </p>
                          </div>

                          <div v-if="showContacts == true" class="mb-1">
                            Kontaktperson:
                            <b-input v-model="order.contact_name"></b-input>
                          </div>

                          <div v-if="showContacts == false">

                            <div v-if="order.contact_email1">
                              E-post:
                              <p>{{ order.contact_email1 }}</p>
                            </div>

                            <div v-if="order.contact_email2">
                              E-post (Alternativ):
                              <p>{{ order.contact_email2 }}</p>
                            </div>

                          </div>

                          <div v-if="showContacts == true" class="mb-1">
                            E-post:
                            <b-input v-model="order.contact_email1"></b-input>
                          </div>

                          <div v-if="showContacts == true" class="mb-1">
                            E-post (Alternativ):
                            <b-input v-model="order.contact_email2"></b-input>
                          </div>

                          <div v-if="showContacts == false">
                            <div v-if="order.contact_phone">
                              Telefon:
                              <p>{{ order.contact_phone }}</p>
                            </div>
                          </div>

                          <div v-if="showContacts == true" class="mb-1">
                            Telefon:
                            <b-input v-model="order.contact_phone"></b-input>
                          </div>

                          <b-link v-if="showContacts == true" @click="saveContact()" class="card-link mb-3">Lagre
                            kontaktperson</b-link>

                          <div v-if="order.customer_company.invoice_method == 'email'">
                            EHF faktura:
                            <p>{{ order.customer_company.invoice_email }}</p>
                          </div>

                          <div v-if="order.customer_company.invoice_method == 'ehf'">
                            EHF faktura:
                            <p>{{ order.customer_company.invoice_ehf }}</p>
                          </div>

                          <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                            Adresse:
                            <p>{{ order.customer_company.invoice_address }}</p>
                          </div>

                          <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                            Postnummer:
                            <p>{{ order.customer_company.invoice_postcode }}</p>
                          </div>

                          <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                            Poststed:
                            <p>{{ order.customer_company.invoice_city }}</p>
                          </div>

                          <div v-if="order.customer_ref">
                            Kundens referanse:
                            <p>{{ order.customer_ref }}</p>
                          </div>

                          <b-collapse id="viewCustomerDetails" class="mt-2">

                            <vue-json-pretty :data="this.order.customer_company"></vue-json-pretty>
                            <br />
                          </b-collapse>

                        </b-card>

                        <!-- Order details -->

                        <b-card class="mb-3" v-if="order.type == 'Avlusning'">
                          <h6>Avlusning</h6>

                          <b-col>
                            Lokasjon:
                            <p>
                              {{ order.site.name }}

                            </p>

                          </b-col>

                          <b-col>

                            Startdatto:
                            <p>
                              {{$date(order.startdate).format("DD.MM.YYYY")}}

                              - {{ order.startdate | dayjs("from") }}

                            </p>

                          </b-col>

                          <b-col>
                            Antall merder:
                            <p v-if=order.details>
                              {{order.details.cages.length}}

                            </p>
                          </b-col>

                          <b-col>
                            Total biomasse bestilt:
                            <p v-if="order.details">
                              {{
                                order.details.biomass_ordered
                                  | numeralFormat("0,0[.]00 kg")
                              }}
                              kg
                            </p>

                          </b-col>

                        </b-card>

                        <!-- Vessel information -->

                        <b-card mb-3 >
                          <h6>Fartøy</h6>

                          <b-row>
                            <b-col>
                              Navn:
                              <p v-if="order.vessel == null">Ikke valgt</p>
                              <p v-if="order.vessel != null">
                                {{ order.vessel.name }}
                                <br />
                                <small>
                                  <b-link v-b-toggle.viewVesselDetails class="card-link" @click="refreshMap()">Vis
                                    detaljer
                                  </b-link>
                                </small>
                              </p>
                            </b-col>

                            <b-col>
                              Skipper:
                              <p v-if="order.captain == null">Ikke valgt</p>
                              <p v-if="order.captain != null">
                                {{ order.captain.name }}
                              </p>
                            </b-col>

                          </b-row>

                          <b-collapse id="viewVesselDetails" class="mt-2">
                            <br />
                            <vue-json-pretty :data="this.vessel"></vue-json-pretty>
                            <br />
                          </b-collapse>

                        </b-card>

                        <!-- Location information -->

                        <b-card class="mb-3" v-if="order.site.name != null">
                          <h6>Lokasjon</h6>

                          <b-row>
                            <b-col>
                              Navn:
                              <p v-if="order.site.name != null">
                                {{ order.site.number }} -
                                {{ order.site.name }}
                                <br />
                                <small>
                                  <b-link v-b-toggle.viewSiteDetails class="card-link" @click="refreshMap()">Vis
                                    detaljer
                                  </b-link>
                                </small>
                              </p>
                            </b-col>

                            <b-col>
                              Breddegrad:
                              <p v-if="order.site.name != null">
                                {{ order.site.lat }}
                              </p>
                            </b-col>
                            <b-col>
                              Lengdegrad:
                              <p v-if="order.site.name != null">
                                {{ order.site.lng }}
                              </p>
                            </b-col>
                          </b-row>

                          <b-collapse id="viewSiteDetails" class="mt-2">
                            <br />
                            <vue-json-pretty :data="this.order.site"></vue-json-pretty>
                            <br />
                          </b-collapse>
                        </b-card>

                      </b-card-group>

                    </b-col>

                  </b-row>
                </b-card-text>
              </b-tab>

              <!-- Delousing tab   -->
              <b-tab v-if="order.type == 'Avlusning'" @click="getLicecount()" title="Avlusning">
                <b-card-text>
                  <!-- Order main windows -->

                  <b-row>

                    <!-- Order menu -->
                    <b-col md="3">

                      <b-card bg-variant="light">
                        <h6>Avlusning</h6>

                        Antall merder:
                        <p v-if="order.details">
                          {{ order.details.cages.length }}
                        </p>

                        Total biomasse bestilt:
                        <p v-if="order.details">
                          {{order.details.biomass_ordered | numeralFormat("0,0[.]00 kg") }} kg
                        </p>
                        
                       <!--
                        Lusetall før behandling:
                        <p>
                          <b-input type="number" v-model="order.details.licecount_before"></b-input>
                        </p>

                        Lusetall etter behandling:
                        <p>
                          <b-input type="number" v-model="order.details.licecount_after"></b-input>
                        </p> -->


                        <!-- <div v-if="user.role.name == 'Administrator'">
                        <hr>

                        Total biomasse utført:
                        <p>
                          <b-input type="number" v-model="order.details.biomass_total"></b-input>
                        </p>

                        Avtale type:
                        <b-form-select class="mb-3" v-model="order.agreement_type" :options="optionsInvoiceAgreement">
                        </b-form-select>

                        <div v-if="order.agreement_type == 'Pris pr. kg'">
                          Avtalt pris:
                          <b-input class="mb-3" type="number" step="0.1" v-model="order.agreement_price"></b-input>
                        </div>

                        <div v-if="order.agreement_type == 'Pris pr. kg'">
                          Biomasse til fakturering:
                          <b-input class="mb-3" disabled type="number" step="0.1" v-model="order.invoice_biomass">
                          </b-input>

                        </div>

                        <div v-if="order.agreement_type == 'Avtale' || order.agreement_type == 'Fastpris'">
                          Biomasse til fakturering:
                          <b-input class="mb-3" type="number" step="1" v-model="order.invoice_biomass"></b-input>
                        </div>
                        </div> -->

                        <hr>

                        Notat
                        <b-form-textarea v-model="order.details.note" class="mb-3" placeholder="Notat" rows="6"
                          max-rows="12"></b-form-textarea>

                        <b-button @click="saveDetails()" variant="primary">Lagre</b-button>

                        <hr>

                      </b-card>

                    </b-col>

                    <!-- Order details -->

                    <b-col>

                      <b-card>

                        <div class="mb-4" v-if="licecount[0] != null">
                        <h6>Lusetelling</h6>

                        <!-- Licecount table -->
                        
                        <b-table
                          show-empty
                          caption-top
                          stacked="sm"
                          :items="licecount"
                          :fields="licecountFields"
                          :tbody-tr-class="rowLicecount"
                          empty-text="There are no Licecounts to show"
                        >
                          <template v-slot:cell(week)="data">
                            <span v-if="data.item.week != null">{{ data.item.week}} - {{ data.item.year}} </span>  
                          </template>

                            <template v-slot:cell(title)="data">
                            <b-link class="link strong" :href="'#/dashboard/licecount-edit/' + data.item.id">
                              <span v-if="data.item.customer_company != null">
                                {{ data.item.customer_company.name }} <span v-if="data.item.site != null"> ({{ data.item.site.number }} - {{ data.item.site.name }})</span></span>
                            </b-link>
                          </template>  
                      
                          <template v-slot:cell(fishcount)="data">
                            <span v-if="data.item.details.fish != null">{{ data.item.details.fish.length }} </span>  
                          </template>

                          <template v-slot:cell(lice_female)="data">
                            <span v-if="data.item.details.lice_female != null">{{ data.item.details.lice_female | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                          <template v-slot:cell(lice_moving)="data">
                            <span v-if="data.item.details.lice_moving != null">{{ data.item.details.lice_moving | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                          <template v-slot:cell(lice_persist)="data">
                            <span v-if="data.item.details.lice_persist != null">{{ data.item.details.lice_persist | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                          <template v-slot:cell(temperature)="data">
                            <span v-if="data.item.details.temperature_sea != null">{{ data.item.temperature_sea | numeralFormat("0,0[.]00") }} </span>  
                          </template>

                        <template v-slot:cell(createdAt)="data">
                            {{ $date(data.value).format("DD.MM.YYYY HH:mm") }}
                          </template> 

                          <template v-slot:cell(owner)="data">
                            <span v-if="data.item.owner_username != null"> {{ data.item.owner_username }}</span>
                          </template> 

                          <template #cell(actions)="row">
                            <b-button variant="primary" class="mr-1 float-center" size="sm" @click="editLicecount(row.item.id)">
                              Åpne</b-button>
                          </template>
                    
                        </b-table>
                        
                        <hr>
                        </div>

                        <h6>Merder</h6>

                        <b-form inline class="mb-3">
                          <label class="sr-only">Merd nummer</label>

                          <b-form-input v-model.number="cage.from_cage" type="text" class="mb-2 mr-sm-2 mb-sm-0"
                            placeholder="Fra merdnummer"></b-form-input>

                          <b-form-input v-model.number="cage.to_cage" type="text" class="mb-2 mr-sm-2 mb-sm-0"
                            placeholder="Til merdnummer"></b-form-input>

                          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input type="number" v-model.number="cage.biomass" placeholder="Biomasse (kg)">
                            </b-form-input>
                          </b-input-group>

                          <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                            <b-form-input type="number" min="0" max="25" step="0.1" v-model.number="cage.averageweight"
                              placeholder="Snittvekt fisk"></b-form-input>
                          </b-input-group>

                        </b-form>

                        <b-input-group class="mb-3">

                          <b-form-input v-model.number="cage.note" id="inline-form-input-name"
                            class="mb-2 mr-sm-2 mb-sm-0" placeholder="Notat"></b-form-input>

                        </b-input-group>
                        <b-button class="mb-3" @click="addCage()" variant="primary">Legg til</b-button>
                        <br>

                        <b-table v-if="this.trip.cages[0] != null" striped hover :fields="cageFields" :items="this.trip.cages">

                          <template v-slot:cell(cages)="data">{{data.item.cagenumber }} </template>

                          <template v-slot:cell(fishcount)="data"> {{ data.item.fishcount | numeralFormat("0,0[.]") }}
                          </template>

                          <template v-slot:cell(averageweight)="data">{{ data.value }} kg</template>

                          <template v-slot:cell(biomass)="data">{{data.value | numeralFormat("0,0[.]00 kg")}} kg</template>

                          <template v-slot:cell(actions)="data">
                            <b-button variant="primary" size="sm" @click="removeCage(data.item)">Fjern</b-button>
                          </template>

                          <br />
                        </b-table>

                      </b-card>
                    </b-col>

                  </b-row>

                </b-card-text>
              </b-tab>

              <!-- Tab for service work -->
              <b-tab v-if="order.type == 'Servicearbeid'" title="Servicearbeid">
                <b-card-text>
                  <!-- Order details -->
                  <b-row>
                    <b-col>
                      <p>{{ order.type }}</p>
                      <hr />
                      <b-form-group label="Notarbeid" v-slot="{ ariaDescribedby }">
                        <b-form-checkbox-group v-model="order.details.servicework" :options="serviceOptions"
                          :aria-describedby="ariaDescribedby" name="flavour-2a" stacked></b-form-checkbox-group>
                      </b-form-group>
                    </b-col>

                    <b-col>
                      <p>Notat</p>
                      <hr />

                      <b-form-textarea class="mt-3" id="textarea" v-model="order.details.note" placeholder="Notat"
                        rows="6" max-rows="6"></b-form-textarea>
                    </b-col>
                  </b-row>
                </b-card-text>
              </b-tab>

              <!-- Tab for Wellboat -->
              <b-tab v-if="order.type == 'Brønnbåt'" title="Brønnbåt">

                <b-row>

                  <b-col md="3">
                    <b-card bg-variant="light">
                      <h6>Brønnbåt</h6>

                      <b-form-group class="mr-3 mb-3" label="Transport type">
                        <span v-if="order.details.transport == 'to_location'">Fra lokasjon til lokasjon</span>
                        <span v-if="order.details.transport == 'to_factory'">Fra lokasjon til slakteri</span>
                      </b-form-group>


                      <b-form-group class="mr-3 mb-3" label="Fra lokasjon">
                        {{order.site.number}} - {{order.site.name}}
                      </b-form-group>


                    <div v-if="order.details.destination != null && order.site != null && order.type == 'Brønnbåt'">

                      <div class="mb-3" v-if="order.details.transport == 'to_location'">
                        <b-form-group class="mr-3 mb-3" label="Til lokasjon">
                          {{order.details.destination.number}} - {{order.details.destination.name}}
                        </b-form-group>
                      </div>


                      <div class="mb-3" v-if="order.details.transport == 'to_factory'">
                        <b-form-group class="mr-3 mb-3" label="Til fabrikk">
                          {{order.details.destination.approval}} - {{order.details.destination.name}}
                        </b-form-group>
                      </div>

                    </div>

                      <b-form-group class="mr-3 mb-3" label="Fiskeslag">
                        <b-form-select class="mr-3" v-model="order.details.species" :options="wellboatSpecies">
                        </b-form-select>
                      </b-form-group>

                      <b-form-group class="mr-3 mb-3" label="Antall fisk">
                        <b-form-input class="mr-3" type="number" v-model="order.details.fishcount"></b-form-input>

                      </b-form-group>

                      <b-form-textarea class="mt-3 mb-3" id="textarea" v-model="order.details.note" placeholder="Notat"
                        rows="6" max-rows="6"></b-form-textarea>

                      <b-button variant="primary" @click="updateOrder()">Lagre</b-button>

                    </b-card>
                  </b-col>

                  <b-col md="9">

                    <b-card>

                    <h6 v-if="this.order.worklogs[0] == null">Ingen logger tilgjengelig </h6>

                    <ul class="timeline">
                      <li class="mb-3" v-for="worklog in orderBy(this.order.worklogs, 'from')" :key="worklog.id">

                        <h5>{{worklog.action}} <small>({{worklog.duration}} timer)</small> </h5>
                        <p>{{ $date(worklog.from).format("DD.MM.YYYY HH:mm")}} -
                          {{ $date(worklog.to).format("DD.MM.YYYY HH:mm")}} </p>

                        <p>{{worklog.description}}</p>
                        <br>

                      </li>
                    </ul>

                    </b-card>
                   
                  </b-col>


                </b-row>





                <!-- Map -->
                <!-- <b-col>

                <b-card v-if="details.destination.lat == null || site == null " bg-variant="light" style="height: 350px">
                </b-card>

                <div v-if="details.destination.lat != null && site != null ">

                  <l-map ref="map" :zoom="4" v-bind:center="[details.destination.lat, details.destination.lng]"
                    style="height: 350px">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>

                    <l-circle :lat-lng="[site.lat, site.lng]" :color="circle.color" :radius="circle.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        <span>Fra lokasjon: <br> {{ site.number }} - {{ site.name }}</span>

                      </l-tooltip>


                    </l-circle>


                    <l-circle :lat-lng="[details.destination.lat, details.destination.lng]" :color="circle.color"
                      :radius="circle.radius">

                      <l-tooltip :options="{ permanent: true, interactive: true }">
                        <span v-if="details.transport == 'to_location'">Til lokasjon: <br>
                          {{ details.destination.number }} -
                          {{ details.destination.name }}</span>
                        <span v-if="details.transport == 'to_factory'">Til slakteri: <br>
                          {{ details.destination.approval }} -
                          {{ details.destination.name }}</span>
                      </l-tooltip>


                    </l-circle>


                  </l-map>

                </div>

              </b-col> -->
              </b-tab>

              <!-- Trips Tab -->
              <b-tab title="Tur rapport">
                <b-button
                  variant="primary"
                  class="mt-2 mb-4"
                  @click="openTripModal('new')"
                >
                  Opprett ny rapport
                </b-button>

                <b-table
                  :items="order.trips"
                  :fields="tripFields"
                >

                <template v-slot:cell(tripNumber)="data">
                  {{data.item.header?.tripNumber}}
                </template>

                <template v-slot:cell(vessel)="data">
                  {{data.item.header?.vessel}}
                </template>

                <template v-slot:cell(location)="data">
                  {{data.item.header?.location}}
                </template>
                  
          
                  <template #cell(actions)="{ item }">
                    <b-button
                    class="mr-2"
                      size="md"
                      variant="primary"
                      @click="openTripPDF(item)"
                    >
                      Åpne PDF
                    </b-button>

                     
                    <b-button
                      size="md"
                      variant="primary"
                      @click="openTripModal('edit', item)"
                    >
                      Rediger
                    </b-button>

                  </template>
                </b-table>

                <!-- Trip - Edit modal -->
                <b-modal
                    id="tripModal"
                    :title="tripModalTitle"
                    @hide="resetTripForm"
                    hide-footer
                    size="xl"
                  >
            
                <!-- HEADER -->
                <b-card class="mb-3" title="Fartøy og lokalitet">

                  <b-row>

                    <b-col md="2">
                      <b-form-group label="Tur nr.">
                        <b-form-input v-model="trip.header.tripNumber" disabled />
                      </b-form-group>
                    </b-col>

                    <b-col md="2">
                    <b-form-group>
                      <b-form inline>
                        <b-form-group label="Turstart" class="mb-2 mr-3">
                          <b-form-datepicker
                            v-model="trip.header.tripStart"
                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                            locale="no"
                            required
                            @input="updateYearWeekFromTripStart"
                          />
                        </b-form-group>
                        
                      </b-form>
                    </b-form-group>
                    </b-col>

                    <b-col md="2">
                      <b-form-group label="År / uke">
                        <b-form-input v-model="trip.header.yearWeek" disabled />
                      </b-form-group>
                    </b-col>

                    <b-col md="3">
                      <b-form-group label="Fartøy">
                        <b-form-input v-model="trip.header.vessel" required />
                      </b-form-group>
                    </b-col>

  
                    <b-col md="3">
                      <b-form-group label="Skipper">
                        <b-form-input v-model="trip.header.captain" required />
                      </b-form-group>
                    </b-col>



                  </b-row>

         
                  <!-- Customer -->

                  <b-row>
                    <b-col md="3">
                      <b-form-group label="Kunde">
                        <b-form-input v-model="trip.header.customer" required />
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group label="Kontaktperson">
                        <b-form-input v-model="trip.header.customerName" required />
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group label="Telefon">
                        <b-form-input v-model="trip.header.customerTel" required />
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group label="Kunde e-post">
                        <b-form-input v-model="trip.header.customerEmail" required />
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Location -->

                  <b-row>
                    <b-col md="4">
                      <b-form-group label="Lokalitet">
                        <b-form-input v-model="trip.header.location" />
                      </b-form-group>
                    </b-col>
                    <b-col md="2">
                      <b-form-group label="Konsesjonsnr.">
                        <b-form-input v-model="trip.header.consessionNr" />
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="Avgangshavn">
                        <b-form-input v-model="trip.header.departurePort" />
                      </b-form-group>
                    </b-col>
    
                  </b-row>


    
                </b-card>

                <!-- 1. LASTING -->
                <b-card class="mb-3" title="1. Lasting">
                  <b-row>
                    <!-- Ankomst lasteplass -->

                    <b-col md="4">

                      <b-form-group label="Ankomst lasteplass">
                        <b-form inline>
                          <b-form-datepicker
                            v-model="trip.loading.arrivalDate"
                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                            locale="no"
                            required
                          />
                          <b-form-input
                            v-model="trip.loading.arrivalTime"
                            type="time"
                            placeholder="HH:mm"
                            locale="no"
                            required
                          />
                        </b-form>
                        
                      </b-form-group>

                    </b-col>


                    <b-col md="4">

                      <b-form-group label="Lasting startet">
                        <b-form inline>
                          <b-form-datepicker
                            v-model="trip.loading.startDate"
                            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                            locale="no"
                            required
                          />
                          <b-form-input
                            v-model="trip.loading.startTime"
                            type="time"
                            placeholder="HH:mm"
                            locale="no"
                            required
                          />
                        </b-form>
                      </b-form-group>

                      <!-- Dropdown wit -->

                    </b-col>

                    <b-col md="4">

                      <!-- Dropdown with type fish (in norwegian) -->

                      <b-form-group label="Fiskeslag">
                        <b-form-select v-model="trip.loading.species" :options="speciesOptions"></b-form-select>
                      </b-form-group>
                    
                    </b-col>
                  
                  </b-row>

                  <hr>

                  <h6>Merder</h6>
                  <b-form label="Merder" inline class="mb-4">

                    <b-form-group  class="" label="Merd nummer">
                    <b-form-input v-model.number="cage.number" type="text" class=""
                      placeholder="Merd nummer"></b-form-input>
                    </b-form-group>

                    <b-form-group  class="ml-3" label="Antall fisk">
                      <b-form-input type="number" v-model.number="cage.fishcount" placeholder="Antall fisk"></b-form-input>
                    </b-form-group >        

                    <b-form-group class="ml-3" label="Snittvekt fisk">
                      <b-form-input type="number" v-model.number="cage.averageweight" placeholder="Snittvekt fisk (kg)"></b-form-input>
                    </b-form-group >
                    
                    <!-- Dropdown -->
                    <b-form-group class="ml-3" label="Lasterom">
                      <b-form-select v-model="cage.well" placeholder="Lasterom" :options="wellOptions"></b-form-select>   
                    </b-form-group>   

                    <b-input-group class="mt-4 ml-3">
                      <b-button @click="addCageTrip()" variant="primary">Legg til</b-button>
                    </b-input-group>
                      
                  </b-form>



                  <b-table class="mt-3" v-if="this.trip.cages[0] != null" striped hover :fields="tripCageFields"
                    :items="this.trip.cages">

                    <template v-slot:cell(cages)="data">{{data.item.number}} </template>

                    <template v-slot:cell(cagees)="data">{{ data.item.fishcount }}</template>

                    <template v-slot:cell(cageaverageweight)="data">{{ data.item.averageweight }} kg </template>

                    <template v-slot:cell(biomass)="data">
                      {{ data.value.toFixed(0) }} kg
                    </template>

                    <template v-slot:cell(actions)="data">
                      <b-button variant="primary" size="sm" @click="removeCageTrip(data.item)">Fjern</b-button>
                    </template>

                  </b-table>
                

                  <!-- RIGHT COLUMN: sums, distribution, O₂, remarks, signature -->
                  <b-row class="mt-3">
                    

                  <b-col md="6" v-if="trip.cages.length > 0">
                     
                      <!-- Total -->
                      <b-form-group label="Totalt">
                        <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>Antall fisk:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.loading.sumMerdsCount"
                            type="number"
                            placeholder="%"
                            disabled
                          />
                        </b-input-group>
                        <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>Snittvekt:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.loading.avgWeight"
                            type="number"
                            placeholder="kg"
                            disabled
                          />
                          <b-input-group-append is-text>kg</b-input-group-append>
                        </b-input-group>
                  
                      <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>Biomasse:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.loading.sumMerdsWeight"
                            type="number"
                            placeholder="kg"
                            disabled
                          />
                          <b-input-group-append is-text>kg</b-input-group-append>
                        </b-input-group>
                      </b-form-group>

                    </b-col>

                    <b-col md="6" v-if="trip.cages.length > 0">
                
                      <!-- distribution -->
                      <b-form-group label="Fordeling i lasterom (%)">
                        <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>BB:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.loading.distributionBB"
                            type="number"
                            placeholder="%"
                            disabled
                          />
                          <b-input-group-append is-text>%</b-input-group-append>
                        </b-input-group>
                        <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>STB:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.loading.distributionSTB"
                            type="number"
                            placeholder="%"
                            disabled
                          />
                          <b-input-group-append is-text>%</b-input-group-append>
                        </b-input-group>
                  
                      <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>Midt:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.loading.distributionMidt"
                            type="number"
                            placeholder="%"
                            disabled
                          />
                          <b-input-group-append is-text>%</b-input-group-append>
                        </b-input-group>
                      </b-form-group>

                    </b-col>

                    <hr>

                  </b-row>


                  <!-- remarks -->
                  <b-form-group class="mt-3" label="Anmerkning til lasting">
                        <b-form-textarea
                          v-model="trip.loading.remarksLoading"
                          rows="3"
                          placeholder="Skriv inn…"
                        />
                  </b-form-group>

                  <!-- Loading completed -->
             

                  <b-form-group label="Lasting avsluttet">
                    <b-form inline>
                      <b-form-datepicker
                        v-model="trip.loading.endDate"
                        :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                        locale="no"
                        required
                      />
                      <b-form-input
                        v-model="trip.loading.endTime"
                        type="time"
                        placeholder="HH:mm"
                        locale="no"
                        required
                      />



                    </b-form>
              
                    
                    
                  </b-form-group>

                </b-card>

                <!-- 2. Reise -->
                <b-card class="mb-3" title="2. Reise">
                    
                  <b-row>
                      <b-col md="12">
                        <b-form-group label="Avreise tidspunkt">
                          <b-form inline>
                            <b-form-group label="Dato" class="mr-3">
                              <b-form-datepicker
                                v-model="trip.travel.recordedDate"
                                :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                                locale="no"
                                required
                              />
                            </b-form-group>

                            <b-form-group label="Tidspunkt" class="">
                              <b-form-input
                                v-model="trip.travel.recordedTime"
                                type="time"
                                placeholder="HH:mm"
                                locale="no"
                                required
                              />
                            </b-form-group>
                            
            
                            <!-- O2 departure -->
      
                      
                              <b-form-group label="O²-metning avgang" class="ml-3">
                                <b-input-group>
                                  <b-form-input
                                    v-model="trip.loading.oxygenDeparture"
                                    type="number"
                                    placeholder="%"
                                  />
                                </b-input-group>
                              </b-form-group>
                            

                              <b-form-group label="Avlest sjøtemperatur" class="ml-3">
                                <b-form-input
                                  v-model="trip.unloading.seaTemperature"
                                />
                              </b-form-group>


                          </b-form>
                        </b-form-group>
                        
                      </b-col>
                    </b-row>

                          <b-row>
                            <b-col md="6">
                              <b-form-group label="Svimere / dødfisk underveis">
                                <b-form-input
                                  v-model="trip.unloading.deadFishCount"
                                  type="number"
                                />
                              </b-form-group>

                              <b-form-group label="Oppførsel fisk">
                                <b-form-input
                                  v-model="trip.unloading.fishBehaviour"
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-form-group label="Anmerkning til reise">
                          <b-form-textarea
                            v-model="trip.travel.remarks"
                            rows="3"
                          />
                        </b-form-group>
                </b-card>

                <!-- 3. Lossing -->
                <b-card class="mb-3" title="3. Lossing">
                  <b-row>
                    <!-- All three date/time groups in one row -->
                    <b-col md="4">
                      <b-form-group label="Ankomst losseplass">
                        <b-form inline>
                          <b-form-group label="Dato" class="mb-2 mr-3">
                            <b-form-datepicker
                              v-model="trip.unloading.arrivalDate"
                              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                              locale="no"
                              required
                            />
                          </b-form-group>
                          <b-form-group label="Tidspunkt" class="mb-2">
                            <b-form-input
                              v-model="trip.unloading.arrivalTime"
                              type="time"
                              placeholder="HH:mm"
                              locale="no"
                              required
                            />
                          </b-form-group>
                        </b-form>
                      </b-form-group>
                    </b-col>
                    <b-col md="4">
                      <b-form-group label="Start lossing">
                        <b-form inline>
                          <b-form-group label="Dato" class="mb-2 mr-3">
                            <b-form-datepicker
                              v-model="trip.unloading.startDate"
                              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                              locale="no"
                              required
                            />
                          </b-form-group>
                          <b-form-group label="Tidspunkt" class="mb-2">
                            <b-form-input
                              v-model="trip.unloading.startTime"
                              type="time"
                              placeholder="HH:mm"
                              locale="no"
                              required
                            />
                          </b-form-group>
                        </b-form>
                      </b-form-group>
                    </b-col>
                   
                  </b-row>

                  <hr>

                  <h6>Merder</h6>
                  <b-form label="Merder" inline class="mb-4">

                    <b-form-group class="" label="Merd nummer">
                      <b-form-input v-model.number="unloadingCage.number" type="text" class=""
                        placeholder="Merd nummer"></b-form-input>
                    </b-form-group>

                    <b-form-group class="ml-3" label="Antall fisk">
                      <b-form-input type="number" v-model.number="unloadingCage.fishcount" placeholder="Antall fisk"></b-form-input>
                    </b-form-group>

                    <b-form-group class="ml-3" label="Snittvekt fisk">
                      <b-form-input type="number" v-model.number="unloadingCage.averageweight" placeholder="Snittvekt fisk (kg)"></b-form-input>
                    </b-form-group>

                    <b-input-group class="mt-4 ml-3">
                      <b-button @click="addUnloadingCage()" variant="primary">Legg til</b-button>
                    </b-input-group>
                      
                  </b-form>

                  <b-table class="mt-3" v-if="this.trip.unloadingCages && this.trip.unloadingCages[0] != null" striped hover :fields="tripUnloadingCageFields"
                    :items="this.trip.unloadingCages">

                    <template v-slot:cell(cages)="data">{{data.item.number}} </template>

                    <template v-slot:cell(fishcount)="data">{{ data.item.fishcount }}</template>

                    <template v-slot:cell(cageaverageweight)="data">{{ data.item.averageweight }} kg </template>

                    <template v-slot:cell(biomass)="data">
                      {{ data.value.toFixed(0) }} kg
                    </template>

                    <template v-slot:cell(actions)="data">
                      <b-button variant="primary" size="sm" @click="removeUnloadingCage(data.item)">Fjern</b-button>
                    </template>

                  </b-table>

                  <!-- RIGHT COLUMN: sums -->
                  <b-row class="mt-3">
                    <b-col md="6" v-if="trip.unloadingCages && trip.unloadingCages.length > 0">
                      <!-- Total -->
                      <b-form-group label="Totalt">
                        <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>Antall fisk:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.unloading.sumMerdsCount"
                            type="number"
                            disabled
                          />
                        </b-input-group>
                        <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>Snittvekt:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.unloading.avgWeight"
                            type="number"
                            placeholder="kg"
                            disabled
                          />
                          <b-input-group-append is-text>kg</b-input-group-append>
                        </b-input-group>
                        <b-input-group class="mb-2">
                          <b-input-group-prepend is-text>Biomasse:</b-input-group-prepend>
                          <b-form-input
                            v-model="trip.unloading.sumMerdsWeight"
                            type="number"
                            placeholder="kg"
                            disabled
                          />
                          <b-input-group-append is-text>kg</b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <hr>

                  <!-- Unloading remarks -->
                  <b-form-group class="mt-3" label="Anmerkning til lossing">
                    <b-form-textarea
                      v-model="trip.unloading.remarksUnloading"
                      rows="3"
                      placeholder="Skriv inn…"
                    />
                  </b-form-group>


                
                      <b-form-group label="Ferdig losset">
                        <b-form inline>
                          <b-form-group label="Dato" class="mb-2 mr-3">
                            <b-form-datepicker
                              v-model="trip.unloading.endDate"
                              :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }"
                              locale="no"
                              required
                            />
                          </b-form-group>
                          <b-form-group label="Tidspunkt" class="mb-2">
                            <b-form-input
                              v-model="trip.unloading.endTime"
                              type="time"
                              placeholder="HH:mm"
                              locale="no"
                              required
                            />
                          </b-form-group>
                        </b-form>
                      </b-form-group>
                  
                      
                </b-card>

                <!-- Footer -->

                  <div class="d-flex justify-content-between mt-4">
                  
                    <b-button
                      v-if="isEditing"
                      variant="danger"
                      class="ml-2"
                      @click="deleteTrip"
                    >
                      Slett tur
                    </b-button>

                    <div class="ml-auto">

                      <b-button class="mr-2" variant="secondary-outline" @click="$bvModal.hide('tripModal')">
                        Avbryt
                      </b-button>

                      <b-button @click="saveTrip()" variant="primary">
                        {{ isEditing ? 'Oppdater tur' : 'Opprett tur' }}
                      </b-button>
                    </div>
                  </div>

                </b-modal>

                <!-- Trip PDF modal -->

                <b-modal id="tripPDFModal" size="lg" hide-footer>
                  <template #modal-title>
                    <span>Tur rapport - {{ trip.header?.tripNumber }}</span>
                  </template>

                  <vue-html2pdf
                    :show-layout="false"
                    :float-layout="false"
                    :enable-download=" true"
                    :preview-modal="false"
                    :filename="`Tur ${trip.header?.tripNumber || ''} - ${trip.header?.tripStart || ''}.pdf`"
                    :manual-pagination="true"
                    pdf-format="a4"
                    pdf-content-width="100%"
                    :pdf-options="pdfOptions"
                    ref="tripHtml2Pdf"
                  >
                    <section slot="pdf-content" class="trip-pdf-content p-3" style="background: #fff; color: #222; font-size: 13px;">
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td colspan="4" style="font-weight:bold; font-size:18px; text-align:center; border-bottom:1px solid #333;">Eines AS - Tur rapport - {{ trip.header?.tripNumber }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Fartøy:</td>
                          <td>{{ trip.header.vessel }}</td>
                          <td style="font-weight:bold;">Tur nr.:</td>
                          <td>{{ trip.header.tripNumber }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Skipper:</td>
                          <td>{{ trip.header.captain }}</td>
                          <td style="font-weight:bold;">År / uke:</td>
                          <td>{{ trip.header.yearWeek }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Kunde:</td>
                          <td>{{ trip.header.customer }}</td>
                          <td style="font-weight:bold;">Kontaktperson:</td>
                          <td>{{ trip.header.customerName }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Telefon:</td>
                          <td>{{ trip.header.customerTel }}</td>
                          <td style="font-weight:bold;">Kunde e-post:</td>
                          <td>{{ trip.header.customerEmail }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Lokalitet:</td>
                          <td>{{ trip.header.location }}</td>
                          <td style="font-weight:bold;">Konsesjonsnr.:</td>
                          <td>{{ trip.header.consessionNr }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Avgangshavn:</td>
                          <td>{{ trip.header.departurePort }}</td>
                          <td style="font-weight:bold;">Turstart:</td>
                          <td>{{ customDateFormatter(trip.header.tripStart) }}</td>
                        </tr>
                      </table>

                      <h5 class="mt-4 mb-2">1. Lasting</h5>
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td style="font-weight:bold;">Ankomst lasteplass:</td>
                          <td>{{ customDateFormatter(trip.loading.arrivalDate) }} {{ trip.loading.arrivalTime }}</td>
                          <td style="font-weight:bold;">Lasting startet:</td>
                          <td>{{ customDateFormatter(trip.loading.startDate) }} {{ trip.loading.startTime }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Fiskeslag:</td>
                          <td>{{ trip.loading.species }}</td>
                          <td style="font-weight:bold;">Lasting avsluttet:</td>
                          <td>{{ customDateFormatter(trip.loading.endDate) }} {{ trip.loading.endTime }}</td>
                        </tr>
                      </table>
                      <div class="mt-2">
                        <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                          <tr style="background:#f5f5f5; font-weight:bold;">
                            <td>Merd</td>
                            <td>Antall fisk</td>
                            <td>Snittvekt (kg)</td>
                            <td>Lasterom</td>
                            <td>Biomasse (kg)</td>
                          </tr>
                          <tr v-for="cage in trip.cages" :key="cage.number">
                            <td>{{ cage.number }}</td>
                            <td>{{ cage.fishcount }}</td>
                            <td>{{ cage.averageweight }}</td>
                            <td>{{ cage.well }}</td>
                            <td>{{ (cage.fishcount * cage.averageweight).toFixed(0) }}</td>
                          </tr>
                        </table>
                      </div>
                      <div class="mt-2">
                        <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                          <tr>
                            <td style="font-weight:bold;">Totalt antall fisk:</td>
                            <td>{{ trip.loading.sumMerdsCount }}</td>
                            <td style="font-weight:bold;">Snittvekt:</td>
                            <td>{{ trip.loading.avgWeight }} kg</td>
                            <td style="font-weight:bold;">Biomasse:</td>
                            <td>{{ trip.loading.sumMerdsWeight }} kg</td>
                          </tr>
                          <tr>
                            <td style="font-weight:bold;">Fordeling BB:</td>
                            <td>{{ trip.loading.distributionBB }}%</td>
                            <td style="font-weight:bold;">STB:</td>
                            <td>{{ trip.loading.distributionSTB }}%</td>
                            <td style="font-weight:bold;">Midt:</td>
                            <td>{{ trip.loading.distributionMidt }}%</td>
                          </tr>
                        </table>
                      </div>
                      <div class="mt-2">
                        <b>O₂-metning avgang:</b> {{ trip.loading.oxygenDeparture }} %
                      </div>
                      <div class="mt-2">
                        <b>Anmerkning til lasting:</b> {{ trip.loading.remarksLoading }}
                      </div>

                      <h5 class="mt-4 mb-2">2. Reise</h5>
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td style="font-weight:bold;">Avreise tidspunkt:</td>
                          <td>{{ customDateFormatter(trip.travel.recordedDate) }} {{ trip.travel.recordedTime }}</td>
                          <td style="font-weight:bold;">Avlest sjøtemperatur:</td>
                          <td>{{ trip.unloading.seaTemperature }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Svimere / dødfisk underveis:</td>
                          <td>{{ trip.unloading.deadFishCount }}</td>
                          <td style="font-weight:bold;">Oppførsel fisk:</td>
                          <td>{{ trip.unloading.fishBehaviour }}</td>
                        </tr>
                      </table>
                      <div class="mt-2">
                        <b>Anmerkning til reise:</b> {{ trip.travel.remarks }}
                      </div>

                      <h5 class="mt-4 mb-2">3. Lossing</h5>
                      <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                        <tr>
                          <td style="font-weight:bold;">Ankomst losseplass:</td>
                          <td>{{ customDateFormatter(trip.unloading.arrivalDate) }} {{ trip.unloading.arrivalTime }}</td>
                          <td style="font-weight:bold;">Start lossing:</td>
                          <td>{{ customDateFormatter(trip.unloading.startDate) }} {{ trip.unloading.startTime }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Ferdig losset:</td>
                          <td>{{ customDateFormatter(trip.unloading.endDate) }} {{ trip.unloading.endTime }}</td>
                          <td style="font-weight:bold;">Dødfisk:</td>
                          <td>{{ trip.unloading.deadFishCount }}</td>
                        </tr>
                        <tr>
                          <td style="font-weight:bold;">Merder:</td>
                          <td colspan="3">{{ trip.unloading.cages }}</td>
                        </tr>
                      </table>

                      <!-- Unloading cages table -->
                      <div class="mt-2" v-if="trip.unloadingCages && trip.unloadingCages.length > 0">
                        <b>Lossing detaljer:</b>
                        <table style="width:100%; border-collapse:collapse; border:1px solid #333; margin-top:8px;">
                          <tr style="background:#f5f5f5; font-weight:bold;">
                            <td>Merd</td>
                            <td>Antall fisk</td>
                            <td>Snittvekt (kg)</td>
                            <td>Biomasse (kg)</td>
                          </tr>
                          <tr v-for="cage in trip.unloadingCages" :key="cage.number">
                            <td>{{ cage.number }}</td>
                            <td>{{ cage.fishcount }}</td>
                            <td>{{ cage.averageweight }}</td>
                            <td>{{ (cage.fishcount * cage.averageweight).toFixed(0) }}</td>
                          </tr>
                        </table>
                        <div class="mt-2">
                          <table style="width:100%; border-collapse:collapse; border:1px solid #333;">
                            <tr>
                              <td style="font-weight:bold;">Totalt antall fisk:</td>
                              <td>{{ trip.unloading.sumMerdsCount }}</td>
                              <td style="font-weight:bold;">Snittvekt:</td>
                              <td>{{ trip.unloading.avgWeight }} kg</td>
                              <td style="font-weight:bold;">Biomasse:</td>
                              <td>{{ trip.unloading.sumMerdsWeight }} kg</td>
                            </tr>
                          </table>
                        </div>
                      </div>

                      <div class="mt-2">
                        <b>Anmerkning til lossing:</b> {{ trip.unloading.remarksUnloading }}
                      </div>
                      <div class="mt-4" style="font-size:11px; color:#666;">
                        Skjemaet sendes leverandør, mottaker, NFT og logistikksansvarlig så snart som mulig etter lossing og arkiveres om bord i minimum 5 år.<br>
                        NB! Enhver reklamasjon må være mottatt av rederiet innen 24 timer etter lossing. Etter denne tid har verken befrakter eller bortfrakter noe ansvar for losset last. All transport skjer på oppdretters forsikring.
                      </div>
                    </section>
                  </vue-html2pdf>

                  <div class="d-flex justify-content-between mb-3">
                    <b-button @click="downloadTripPDF()" variant="primary">Last ned</b-button>
                    <b-button @click="$bvModal.hide('tripPDFModal')" variant="secondary">Lukk</b-button>
                  </div>

                </b-modal>

              </b-tab>

              <!-- Tab for cage cleaning -->
              <b-tab v-if="order.type == 'Notspyling'" title="Notspyling">
                <b-card-text>

                  <b-table v-if="this.order.details.cages[0] != null" striped hover :fields="cageFields"
                    :items="this.order.details.cages">

                  </b-table>

                </b-card-text>
              </b-tab>

              <!-- FLS Tab -->
              <b-tab v-if="order.type == 'Avlusning'" title="FLS">
                <b-card-text>

                  <b-row>

                    <b-col md="3">

                      <div class="mb-3">

                        <b-alert v-if="order.vessel == null" show variant="danger">Fartøy er ikke valgt</b-alert>

                        <b-card bg-variant="light">
                          <h6 v-if="fls.lines > 1">FLS ({{fls.lines}} linjer)</h6>
                          <h6 v-if="fls.lines <= 1">FLS ({{fls.lines}} linje)</h6>
                          <hr>

                            Totalt antall fisk:
                            <p>
                              {{ flsSumFish | numeralFormat("0,0[.]00") }}
                            </p>

                            Total biomasse utført:
                            <p>
                              {{ flsSumBiomass | numeralFormat("0,0[.]00") }} kg
                            </p>

                          <hr>

                          <b-row>

                            <b-col>
                              <label>Fra Merd</label>
                              <b-form-input class="mb-3" v-model="fls.from_cage" placeholder="Merd">
                              </b-form-input>

                            </b-col>

                            <b-col>

                              <label>Til Merd</label>
                              <b-form-input class="mb-3" v-model="fls.to_cage" placeholder="Merd">
                              </b-form-input>

                            </b-col>

                          </b-row>

                          <label>Antall fisk</label>
                          <b-form-input class="mb-3" v-model="fls.fishcount" type="number" placeholder="Antall fisk ">
                          </b-form-input>

                          <label>Biomasse (kg)</label>
                          <b-input-group class="mb-3">
                            <b-input type="number" v-model="fls.biomass"></b-input>
                            <b-input-group-append>
                               <b-input-group-text>kg</b-input-group-text>                             
                            </b-input-group-append>
                          </b-input-group>


                          <label>Kommentar</label>
                          <b-form-textarea class="mb-3" v-model="fls.comment" placeholder="Kommentar" rows="3"
                            max-rows="6"></b-form-textarea>

                          <div>
                            <b-form-checkbox v-model="fls.completed" :value="true" :unchecked-value="false">Avsluttet
                            </b-form-checkbox>

                          </div>

                          <!-- Save and settings buttons -->

                          <b-collapse id="settingsFLS" class="mt-2">
                            <hr>
                            <label>Antall linjer</label>
                            <b-form-input class="mr-3" v-model="fls.lines" type="number" max="5"
                              placeholder="Antall linjer"></b-form-input>

                            <label>Temperatur i luft</label>
                            <b-form-input class="mr-3" v-model="fls.temperature_air" type="number"
                              placeholder="Temperatur i luft"></b-form-input>

                            <label>Temperatur i sjø</label>
                            <b-form-input class="mr-3" v-model="fls.temperature_sea" type="number"
                              placeholder="Temperatur i sjø"></b-form-input>

                          </b-collapse>

                          <b-form inline class="mt-3">

                            <b-button v-if="order.vessel == null" disabled class="mr-1" variant="primary">

                              Lagre </b-button>

                            <b-button v-if="order.vessel != null" class="mr-1" @click="saveFLS()" variant="primary">
                              Lagre</b-button>

                            <b-button v-b-toggle.settingsFLS class="card-link" variant="link">Innstillinger</b-button>

                            <div v-if="fls_lastupdate != null" class="mt-3">
                              Sist oppdatert:
                              {{ $date(fls_lastupdate).format("DD.MM.YYYY HH:mm") }}
                            </div>
                          </b-form>



                        </b-card>
                      </div>

                    </b-col>

                    <!-- Main FLS column. Cage numbers, values -->

                    <b-col md=9>
                      <b-card>
                        <h6>Oversikt</h6>

                        <!-- Line 1 -->

                        <div v-if="fls.lines >= 1">
                          <b-row>
                            <b-col>
                              Linje 1
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line1_ejector" :max="1"
                                variant="danger" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line1_flushpressure" :max="1"
                                variant="warning" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line1_oxygen" :max="200"
                                variant="info" animated></b-progress>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Ejektor trykk</label> 
                               <b-form-spinbutton type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line1_ejector"></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                             <label class="text-center">Spyletrykk</label> 
                              <b-form-spinbutton  type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line1_flushpressure" ></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Oksygen</label> 
                              <b-form-spinbutton type="number" class="mb-3" :min="1" :max="200" :step="1" v-model="fls.data.line1_oxygen" ></b-form-spinbutton>
                            </b-col>
                          </b-row>

                          <hr />
                        </div>

                        <!-- Line 2 -->

                        <div v-if="fls.lines >= 2">
                          <b-row>
                            <b-col>
                              Linje 2
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line2_ejector" :max="1"
                                variant="danger" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line2_flushpressure" :max="1"
                                variant="warning" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line2_oxygen" :max="200"
                                variant="info" animated></b-progress>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Ejektor trykk</label> 
                               <b-form-spinbutton type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line2_ejector"></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                             <label class="text-center">Spyletrykk</label> 
                              <b-form-spinbutton type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line2_flushpressure" ></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Oksygen</label> 
                              <b-form-spinbutton type="number" class="mb-3" :min="1" :max="200" :step="1" v-model="fls.data.line2_oxygen" ></b-form-spinbutton>
                            </b-col>
                          </b-row>

                          <hr />
                        </div>

                        <!-- Line 3 -->

                        <div v-if="fls.lines >= 3">
                          <b-row>
                            <b-col>
                              Linje 3
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line3_ejector" :max="1"
                                variant="danger" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line3_flushpressure" :max="1"
                                variant="warning" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line3_oxygen" :max="200"
                                variant="info" animated></b-progress>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Ejektor trykk</label> 
                               <b-form-spinbutton type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line3_ejector"></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                             <label class="text-center">Spyletrykk</label> 
                              <b-form-spinbutton type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line3_flushpressure" ></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Oksygen</label> 
                              <b-form-spinbutton type="number" class="mb-3" :min="1" :max="200" :step="1" v-model="fls.data.line3_oxygen" ></b-form-spinbutton>
                            </b-col>
                          </b-row>

                          <hr />
                        </div>

                        <!-- Line 4 -->

                        <div v-if="fls.lines >= 4">
                          <b-row>
                            <b-col>
                              Linje 4
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line4_ejector" :max="1"
                                variant="danger" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line4_flushpressure" :max="1"
                                variant="warning" animated></b-progress>
                              <b-progress class="mb-1" height="0.5rem" :value="fls.data.line4_oxygen" :max="200"
                                variant="info" animated></b-progress>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Ejektor trykk</label> 
                               <b-form-spinbutton type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line4_ejector"></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                             <label class="text-center">Spyletrykk</label> 
                              <b-form-spinbutton type="number" class="mb-3" :min="0.01" :max="1" :step="0.01" v-model="fls.data.line4_flushpressure" ></b-form-spinbutton>
                            </b-col>

                            <b-col class="mr-3 text-center">
                              <label class="text-center">Oksygen</label> 
                              <b-form-spinbutton type="number" class="mb-3" :min="1" :max="200" :step="1" v-model="fls.data.line4_oxygen" ></b-form-spinbutton>
                            </b-col>
                          </b-row>
                        </div>

                        <!-- FLS data table -->

                        <b-table class="mt-3" caption-top striped hover :items="this.order.fls" :fields="flsFields"
                          :tbody-tr-class="rowCompleted" empty-text="Ingen data tilgjengelig">
                          <!-- 
                          <template v-slot:table-caption>Totalt antall fisk:
                            {{ flsSumFish | numeralFormat("0,0[.]00") }} - Total biomasse: {{ flsSumBiomass | numeralFormat("0,0[.]00") }}
                            
                            </template> -->

                          <template v-slot:cell(regtime)="data">{{
                              $date(data.value).format("DD.MM.YYYY HH:mm")
                            }}</template>

                          <template v-slot:cell(cage)="data">{{
                              data.item.from_cage
                            }} <span v-if="data.item.to_cage != ''"> - {{
                              data.item.to_cage
                            }} </span> </template>

                          <template v-slot:cell(ejector)="data">
                            {{ data.item.data.line1_ejector }} <span v-if="data.item.lines >= 2">/</span>
                            {{ data.item.data.line2_ejector }} <span v-if="data.item.lines >= 3">/</span>
                            {{ data.item.data.line3_ejector }} <span v-if="data.item.lines >= 4">/</span>
                            {{ data.item.data.line4_ejector }}
                          </template>

                          <template v-slot:cell(flushpressure)="data">
                            {{ data.item.data.line1_flushpressure }} <span v-if="data.item.lines >= 2">/</span>
                            {{ data.item.data.line2_flushpressure }} <span v-if="data.item.lines >= 3">/</span>
                            {{ data.item.data.line3_flushpressure }} <span v-if="data.item.lines >= 4">/</span>
                            {{ data.item.data.line4_flushpressure }}
                          </template>

                          <template v-slot:cell(extrasuction)="data">
                            {{ data.item.data.line1_extrasuction }} <span v-if="data.item.lines >= 2">/</span>
                            {{ data.item.data.line2_extrasuction }} <span v-if="data.item.lines >= 3">/</span>
                            {{ data.item.data.line3_extrasuction }} <span v-if="data.item.lines >= 4">/</span>
                            {{ data.item.data.line4_extrasuction }}
                          </template>

                          <template v-slot:cell(oxygen)="data">
                            {{ data.item.data.line1_oxygen }} <span v-if="data.item.lines >= 2">/</span>
                            {{ data.item.data.line2_oxygen }} <span v-if="data.item.lines >= 3">/</span>
                            {{ data.item.data.line3_oxygen }} <span v-if="data.item.lines >= 4">/</span>
                            {{ data.item.data.line4_oxygen }}
                          </template>

                          <template v-slot:cell(fishcount)="data">{{
                      data.value | numeralFormat("0,0[.]00")
                    }}</template>


                          <template v-slot:cell(biomass)="data">{{
                      data.value | numeralFormat("0,0[.]00")
                    }} kg</template>

                          <template v-slot:cell(completed)="data">
                            <span class="dot text-centre" v-if="data.item.completed == true"></span>
                          </template>

                          <template #cell(actions)="row">

                            <b-button variant="primary" class="mr-1 float-center" size="sm"
                              @click="editFLSModal(row.item)">
                              Rediger</b-button>
                          </template>

                        </b-table>
                      </b-card>

                    </b-col>

                  </b-row>

                  <b-row v-if="hasOfflineFlsDrafts">
                    <b-col>
                      <b-card class="mt-3" bg-variant="light">
                        <h6>FLS-utkast (ikke sendt)</h6>
                        <b-table
                          small
                          responsive="sm"
                          :items="offlineFlsTableItems"
                          :fields="offlineFlsDraftFields"
                          head-variant="light"
                          class="mb-0"
                        >
                          <template #cell(regtime)="data">
                            {{$date(data.value).format("DD.MM.YYYY HH:mm")}}
                          </template>
                          <template #cell(biomass)="data">
                            {{ (data.value || 0) | numeralFormat("0,0[.]00") }} kg
                          </template>
                          <template #cell(comment)="data">
                            <span>{{ data.value }}</span>
                          </template>
                          <template #cell(actions)="row">
                            <b-button
                              size="sm"
                              variant="outline-danger"
                              @click="removeOfflineFlsDraft(row.item.id)"
                            >
                              Fjern
                            </b-button>
                          </template>
                        </b-table>
                      </b-card>
                    </b-col>
                  </b-row>

                  <!-- Edit FLS modal -->

                  <b-modal id="editFLSModal" title="Rediger FLS" size="xl">

                    <!-- Cage numbers, values -->
                    <div class="mb-3">



                      <b-row>

                    <b-col md="2">
                    
                        <label>Tidspunkt</label>
                        <v-date-picker class="mr-3" v-model="editfls.regtime" timezone="Europe/Amsterdam" mode="dateTime" is24hr>
                          <template v-slot="{ inputValue, inputEvents }">
                            <input class="px-2 py-2 border rounded focus:outline focus:border-gray-100" :value="inputValue"
                              v-on="inputEvents" />
                          </template>
                        </v-date-picker>
                   
                      </b-col>


                        <b-col md="2">
                          <label>Fra Merd</label>
                          <b-form-input class="mr-3" v-model="editfls.from_cage" placeholder="Merd">
                          </b-form-input>
                        </b-col>

                        <b-col md="2">
                          <label>Til Merd</label>
                          <b-form-input class="mr-3" v-model="editfls.to_cage" placeholder="Merd">
                          </b-form-input>
                        </b-col>

                        <b-col md="2">
                          <label>Antall fisk</label>
                          <b-form-input class="mr-3" v-model="editfls.fishcount" type="number"
                            placeholder="Antall fisk "></b-form-input>
                        </b-col>

                        <b-col md="2">
                          <label>Biomasse (kg)</label>


                        <b-input-group class="mb-3">
                            <b-input type="number" v-model="editfls.biomass"></b-input>
                            <b-input-group-append>
                               <b-input-group-text>kg</b-input-group-text>
                             
                            </b-input-group-append>
                          </b-input-group>
                        </b-col>



                        <b-col md="2">
                          <div class="mt-3">
                            <br>
                            <b-form-checkbox v-model="editfls.completed" :value="true" :unchecked-value="false">
                              Avsluttet</b-form-checkbox>

                          </div>

                        </b-col>

                        <b-col md="8">
                          <label>Kommentar</label>
                          <b-form-input class="mr-3" v-model="editfls.comment" type="text" placeholder="Kommentar">
                          </b-form-input>
                        </b-col>

                      </b-row>
                    </div>

                    <hr>

                    <!-- Line 1 -->

                    <div v-if="editfls.lines >= 1">
                      <b-row>
                        <b-col>
                          Linje 1
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line1_ejector" :max="1"
                            variant="danger" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line1_flushpressure" :max="1"
                            variant="warning" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line1_oxygen" :max="200"
                            variant="info" animated></b-progress>
                        </b-col>

                        <b-col class="mr-3">
                          Ejektor trykk
                          <b-form-input v-model="editfls.data.line1_ejector" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Spyletrykk
                          <b-form-input v-model="editfls.data.line1_flushpressure" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Oksygen
                          <b-form-input v-model="editfls.data.line1_oxygen" :step="1" :min="1" :max="200" type="number">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <hr />
                    </div>

                    <!-- Line 2 -->

                    <div v-if="editfls.lines >= 2">
                      <b-row v-if="editfls.lines >= 2">
                        <b-col>
                          Linje 2
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line2_ejector" :max="1"
                            variant="danger" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line2_flushpressure" :max="1"
                            variant="warning" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line2_oxygen" :max="200"
                            variant="info" animated></b-progress>
                        </b-col>

                        <b-col class="mr-3">
                          Ejektor trykk
                          <b-form-input v-model="editfls.data.line2_ejector" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Spyletrykk
                          <b-form-input v-model="editfls.data.line2_flushpressure" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Oksygen
                          <b-form-input v-model="editfls.data.line2_oxygen" :step="1" :min="1" :max="200" type="number">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <hr />
                    </div>

                    <!-- Line 3 -->

                    <div v-if="editfls.lines >= 3">
                      <b-row v-if="editfls.lines >= 3">
                        <b-col>
                          Linje 3
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line3_ejector" :max="1"
                            variant="danger" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line3_flushpressure" :max="1"
                            variant="warning" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line3_oxygen" :max="200"
                            variant="info" animated></b-progress>
                        </b-col>

                        <b-col class="mr-3">
                          Ejektor trykk
                          <b-form-input v-model="editfls.data.line3_ejector" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Spyletrykk
                          <b-form-input v-model="editfls.data.line3_flushpressure" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Oksygen
                          <b-form-input v-model="editfls.data.line3_oxygen" :step="1" :min="1" :max="200" type="number">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <hr />
                    </div>

                    <!-- Line 4 -->

                    <div v-if="editfls.lines >= 4">
                      <b-row v-if="editfls.lines >= 4">
                        <b-col>
                          Linje 4
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line4_ejector" :max="1"
                            variant="danger" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line4_flushpressure" :max="1"
                            variant="warning" animated></b-progress>
                          <b-progress class="mb-1" height="0.5rem" :value="editfls.data.line4_oxygen" :max="200"
                            variant="info" animated></b-progress>
                        </b-col>

                        <b-col class="mr-3">
                          Ejektor trykk
                          <b-form-input v-model="editfls.data.line4_ejector" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Spyletrykk
                          <b-form-input v-model="editfls.data.line4_flushpressure" :step="0.01" :min="0.01" :max="1"
                            type="number">
                          </b-form-input>
                        </b-col>

                        <b-col class="mr-3">
                          Oksygen
                          <b-form-input v-model="editfls.data.line4_oxygen" :step="1" :min="1" :max="200" type="number">
                          </b-form-input>
                        </b-col>
                      </b-row>
                    </div>

                    <template #modal-footer>
                      <div class="w-100">

                        <b-button variant="outline-danger" class="float-left" @click="deleteFLS()">
                          Slett
                        </b-button>

                        <b-button variant="primary" class="float-right" @click="updateFLS()">
                          Lagre
                        </b-button>

                        <b-button variant="default" class="float-right mr-2" @click="closeFLSModal()">
                          Avbryt
                        </b-button>
                      </div>
                    </template>
                  </b-modal>

                </b-card-text>
              </b-tab>

              <!-- Worklog Tab -->
              <b-tab title="Arbeidslogg">
                <b-card-text>

                  <b-alert
                    v-if="!$isOnline"
                    show
                    variant="danger"
                    class="mb-3"
                  >
                    NB! Du er ikke tilkoblet nett. Arbeidslogg lagres som utkast til du er online igjen.
                  </b-alert>
                  <b-alert
                    v-if="$isOnline && hasOfflineWorklogDrafts"
                    show
                    variant="success"
                    class="mb-3"
                  >
                    <h6 class="alert-heading">Klar til � laste opp arbeidslogg-utkast</h6>
                    <p class="mb-2">Du har lagrede arbeidslogg-utkast som kan lastes opp.</p>
                    <b-button
                      variant="outline-success"
                      class="mr-2"
                      size="sm"
                      :disabled="isUploadingOfflineWorklog"
                      @click="uploadOfflineWorklogDrafts"
                    >
                      Last opp
                    </b-button>
                    <b-button
                      variant="outline-danger"
                      size="sm"
                      :disabled="isUploadingOfflineWorklog"
                      @click="clearOfflineWorklogDrafts"
                    >
                      Fjern utkast
                    </b-button>
                  </b-alert>
                  <b-alert
                    v-if="offlineWorklogError"
                    show
                    variant="danger"
                    class="mb-3"
                  >
                    {{ offlineWorklogError }}
                  </b-alert>

                  <b-row>
                    <b-col md="3">
                      <b-card bg-variant="light">
                        <div>

                          <h6>Arbeidslogg</h6>
                          <b-form-group label="Hendelse" class="mr-3">
                            <b-form-select v-model="worklog.action" :options="worklogOptions"></b-form-select>
                          </b-form-group>

                          <b-form inline class="mb-3">

                            <b-form-group label="Fra dato" class="mr-3">
                              <b-form-datepicker id="startdate" v-model="worklog.startdate"
                                @change="calculateWorklogDuration()"
                                :date-format-options="{ day: '2-digit', month: '2-digit',  year: 'numeric'  }"
                                locale="no">
                              </b-form-datepicker>
                            </b-form-group>

                            <b-form-group label="Fra tidspunkt" class="mr-3">
                              <b-form-input v-model="worklog.fromtime" @change="calculateWorklogDuration()" type="time"
                                placeholder="HH:mm" locale="no"></b-form-input>
                            </b-form-group>

                          </b-form>

                          <b-form inline class="mb-3">

                            <b-form-group label="Til dato" class="mr-3">
                              <b-form-datepicker id="enddate" v-model="worklog.enddate"
                                @change="calculateWorklogDuration()"
                                :date-format-options="{ day: '2-digit', month: '2-digit',  year: 'numeric'  }"
                                locale="no">
                              </b-form-datepicker>
                            </b-form-group>

                            <b-form-group label="Til tidspunkt" class="mr-3">
                              <b-form-input v-model="worklog.totime" @change="calculateWorklogDuration()" type="time"
                                placeholder="HH:mm" locale="no"></b-form-input>
                            </b-form-group>

                          </b-form>

                          <div>
                            <b-form-group label="Antall timer" class="mr-3">
                              <b-form-input v-model="worklog.duration" @change="calculateWorklogDuration()"
                                type="number" placeholder="Antall timer">
                              </b-form-input>
                            </b-form-group>
                          </div>

                          <b-form-textarea class="mt-3" v-model="worklog.description" placeholder="Beskrivelse" rows="4"
                            max-rows="6"></b-form-textarea>
                        </div>

                        <b-button class="mt-3" @click="saveWorklog()" variant="primary">Lagre</b-button>

                      </b-card>

                    </b-col>

                    <!-- Worklog table -->

                    <b-col md="9">

                      <b-card>
                        <h6>Oversikt</h6>

                        <b-table striped hover :items="this.order.worklogs" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :fields="worklogsFields">
                          <template v-slot:table-caption>Totalt: {{ worklogSumHours }} timer</template>

                          <template v-slot:cell(from)="data">{{
                            $date(data.value).format("DD.MM.YYYY HH:mm")}}
                          </template>

                          <template v-slot:cell(to)="data">
                            {{$date(data.value).format("DD.MM.YYYY HH:mm")}}
                          </template>

                          <template v-slot:cell(duration)="data"><span v-if="data.item.billtype == 'Timepris'">{{ data.value }} timer</span></template>

                          <template v-slot:cell(billable)="data">
                            <span class="dot text-centre" v-if="data.item.billable == true"></span>
                          </template>

                          <template #cell(actions)="row">

                            <b-button variant="primary" class="mr-1 float-center" size="sm"
                              @click="editWorklogModal(row.item)">
                              Rediger</b-button>
                          </template>

                        </b-table>
                      </b-card>

                    </b-col>

                  </b-row>

                  <b-row v-if="hasOfflineWorklogDrafts">
                    <b-col>
                      <b-card class="mt-3" bg-variant="light">
                        <h6>Arbeidslogg-utkast (ikke sendt)</h6>
                        <b-table
                          small
                          responsive="sm"
                          :items="offlineWorklogTableItems"
                          :fields="offlineWorklogDraftFields"
                          head-variant="light"
                          class="mb-0"
                        >
                          <template #cell(from)="data">
                            {{$date(data.value).format("DD.MM.YYYY HH:mm")}}
                          </template>
                          <template #cell(to)="data">
                            {{$date(data.value).format("DD.MM.YYYY HH:mm")}}
                          </template>
                          <template #cell(duration)="data">
                            <span>{{ data.value }} timer</span>
                          </template>
                          <template #cell(description)="data">
                            <span>{{ data.value }}</span>
                          </template>
                          <template #cell(actions)="row">
                            <b-button
                              size="sm"
                              variant="outline-danger"
                              @click="removeOfflineWorklogDraft(row.item.id)"
                            >
                              Fjern
                            </b-button>
                          </template>
                        </b-table>
                      </b-card>
                    </b-col>
                  </b-row>

                </b-card-text>

                <!-- Edit Worklog modal -->

                <b-modal id="editWorklogModal" title="Rediger arbeidslogg" size="xl">

                  <div>
                    <b-form inline>

                      <div>
                        <label for="example-input">Hendelse</label>
                        <b-input-group class="mr-3">
                          <b-form-select v-model="editworklog.action" :options="worklogOptions"></b-form-select>
                        </b-input-group>
                      </div>

                      <div>
                        <label for="example-input">Fra dato</label>
                        <b-input-group class="mr-3">
                          <b-form-datepicker id="startdate-edit" v-model="editworklog.startdate"
                            @change="calculateEditWorklogDuration()" locale="no">
                          </b-form-datepicker>
                        </b-input-group>
                      </div>

                      <div>
                        <label for="example-input">Fra tidspunkt</label>
                        <b-input-group class="mr-3">
                          <b-form-input v-model="editworklog.fromtime" @change="calculateEditWorklogDuration()"
                            type="time" placeholder="HH:mm" locale="no"></b-form-input>
                          <b-input-group-append></b-input-group-append>
                        </b-input-group>
                      </div>

                      <div>
                        <label for="example-input">Til dato</label>
                        <b-input-group class="mr-3">
                          <b-form-datepicker id="enddate-edit" v-model="editworklog.enddate"
                            @change="calculateEditWorklogDuration()" locale="no">
                          </b-form-datepicker>
                        </b-input-group>
                      </div>

                      <div>
                        <label for="example-input">Til tidspunkt</label>
                        <b-input-group class="mr-3">
                          <b-form-input v-model="editworklog.totime" @change="calculateEditWorklogDuration()"
                            type="time" placeholder="HH:mm" locale="no"></b-form-input>
                        </b-input-group>
                      </div>

                      <div class="mr-3">
                        <label for="example-input">Antall timer</label>
                        <b-input-group class="mb-2 pt-2">
                          <b-form-input v-model="editworklog.duration" @change="calculateEditWorklogDuration()"
                            type="number" placeholder="Antall timer">
                          </b-form-input>
                        </b-input-group>
                      </div>

                    </b-form>
                    

                    <b-form-textarea class="mt-3" v-model="editworklog.description" placeholder="Beskrivelse" rows="2"
                      max-rows="5"></b-form-textarea>
                  </div>

                  <hr>

                    <b-form v-if="user && user.role && user.role.name == 'Administrator'" inline>

                      <div>
                        <b-form-group label="Fakturer" class="mr-3">
                          <b-form-select v-model="editworklog.billable" :options="billableOptions"></b-form-select>
                        </b-form-group>
                      </div>

                      <div>
                        <b-form-group label="Type" class="mr-3">
                          <b-form-select v-model="editworklog.billtype" :options="billtypeOptions"></b-form-select>
                        </b-form-group>
                      </div>

                      <div v-if="editworklog.billtype == 'Timepris' ">
                        <b-form-group label="Timepris" class="mr-3">
                          <b-form-input v-model="editworklog.rate" @change="calculateEditWorklogDuration()"
                            type="hidden" placeholder="Timepris">
                          </b-form-input>
                        </b-form-group>
                      </div>

                      <div>
                        <b-form-group label="Totalt" class="mr-3">
                          <b-form-input v-model="editworklog.total" type="hidden" placeholder="Totalt">
                          </b-form-input>
                        </b-form-group>
                      </div>

                
                    </b-form>


                  <template #modal-footer>
                    <div class="w-100">

                      <b-button variant="outline-danger" class="float-left" @click="deleteWorklog()">
                        Slett
                      </b-button>

                      <b-button variant="primary" class="float-right" @click="updateWorklog()">
                        Lagre
                      </b-button>

                      <b-button variant="default" class="float-right mr-2" @click="closeWorklogModal()">
                        Avbryt
                      </b-button>
                    </div>
                  </template>

                </b-modal>

              </b-tab>

              <!-- Declarations -->

              <b-tab title="Egenerklæring">
                <b-card-text>

                  <b-row>

                    <b-col md="3">
                      <b-card bg-variant="light">

                        <h6>Egenerklæring</h6>

                        Vask og desinfeksjon fullført:
                        <datepicker class="mr-3 mb-3" v-model="declaration.completed_date" :format="customFormatter"
                          :bootstrap-styling="true"></datepicker>

                        <b-form-textarea class="mt-3" id="textarea" v-model="declaration.note" placeholder="Notat"
                          rows="3" max-rows="6"></b-form-textarea>

                        Godkjent av:
                        <b-form-input class="mt-3 mb-3" v-model="declaration.accepted_by" placeholder="Godkjent av">
                        </b-form-input>

                        <datepicker class="mb-3" v-model="declaration.accepted_date" :format="customFormatter"
                          :bootstrap-styling="true"></datepicker>

                        <b-button class="mb-3" variant="primary" @click="saveDeclaration()">Lagre</b-button>
                        <br />
                      </b-card>

                    </b-col>

                    <b-col md="9">
                      <b-card>

                        <b-form-group label="Vask og desinfeksjon" v-slot="{ ariaDescribedby }">
                          <b-form-checkbox v-model="declaration.details.task_1" :aria-describedby="ariaDescribedby">
                            1. Inntaksrør, fiskepumper, silkasser<span v-if="order.type == 'Avlusning'">, FLS-spyler</span>
                            <br />
                            <small>Pålegges med høytrykksvasker, krypdyse, innvendig i rør
                              og pumper. Preparat Salardes 1,5%</small>
                          </b-form-checkbox>
                          <b-form-checkbox v-if="order.type != 'Brønnbåt'" v-model="declaration.details.task_2" :aria-describedby="ariaDescribedby">
                            2. Lusefilter <br />
                            <small>Spyles med brannslange, legges i et kar med
                              desinfeksjon. Preparat Salardes 1,5%</small>
                          </b-form-checkbox>

                          <b-form-checkbox v-model="declaration.details.task_3" :aria-describedby="ariaDescribedby">
                            {{ declarationNo(3) }}. Utvendig: Dekk, kran, stuyrehus<span v-if="order.type == 'Avlusning'">, FLS-spyler utvendig</span>
                            skutesider<br />
                            <small>Pålegges med høytrykksvasker. Preparat Salardes
                              1,5%</small>
                          </b-form-checkbox>
                          <b-form-checkbox v-model="declaration.details.task_4" :aria-describedby="ariaDescribedby">
                            {{ declarationNo(4) }}. Løfteredskap, løftestropper, diverse løse ting på
                            dekk<br />
                            <small>Pålegges med høytrykksvasker som skum eller med
                              pumpekanne. Preparat Salardes 1,5%</small>
                          </b-form-checkbox>
                          <b-form-checkbox v-model="declaration.details.task_5" :aria-describedby="ariaDescribedby">
                            {{ declarationNo(5) }}. Tauverk og fortøyningsutstyr<br />
                          </b-form-checkbox>
                          <b-form-checkbox v-model="declaration.details.task_6" :aria-describedby="ariaDescribedby">
                            {{ declarationNo(6) }}. Innvendig: styrehus og oppholdsrom<br />
                            <small>Med bøtte og klut. Preparat Såpe</small>
                          </b-form-checkbox>
                          <b-form-checkbox v-model="declaration.details.task_7" :aria-describedby="ariaDescribedby">
                            {{ declarationNo(7) }}. Arbeidstøy<br />
                            <small>Oljeklær og hansker skylles rene. Alle klær vaskes i
                              vaskemaskin på egnet program. Preparat Såpe</small>
                          </b-form-checkbox>
                          <b-form-checkbox v-model="declaration.details.task_8" :aria-describedby="ariaDescribedby">
                            {{ declarationNo(8) }}. Hender<br />
                            <small>Håndvask. Preparat Såpe</small>
                          </b-form-checkbox>
                        </b-form-group>

                      </b-card>

                    </b-col>
                  </b-row>

                  <!-- Main table element -->
                  <!-- <b-table
                show-empty
                caption-top
                stacked="sm"
                :items="order.declarations"
                :fields="fieldsDeclarations"
                empty-text="There are no declarations to show"
              >
                <template v-slot:table-caption>Total:
                  {{ order.declarations.length | numeralFormat }} declarations
                </template>

                <template v-slot:cell(ordertitle)="data">
                  {{ data.item.ordernumber }} - {{ data.item.customer }} ({{
                                data.item.site
                              }})
                </template>

                <template v-slot:cell(completed_date)="data">
                  {{ $date(data.value).format("DD.MM.YYYY") }}
                </template>

                <template v-slot:cell(accepted_date)="data">
                  {{ $date(data.value).format("DD.MM.YYYY") }}
                </template>
              </b-table> -->
                </b-card-text>
              </b-tab>



  <!-- Inovice -->
              <b-tab @click="calculateInvoice()" v-if="user && user.role && user.role.name == 'Administrator'" title="Fakturering">
                <b-card-text>

                  <b-row>

                    <!-- Order details -->

                    <b-col md="3">

                      <b-card bg-variant="light">
                        <h6>Fakturering</h6>

                         <div v-if="order.customer_company.invoice_method == 'email'">
                          Fakturametode:
                          <br>
                          <p>E-post</p>

                          Faktura e-post:
                          <p>{{ order.customer_company.invoice_email }}</p>
                        </div>

                        <div v-if="order.customer_company.invoice_method == 'ehf'">
                          Fakturametode:
                          <br>
                          <p>EHF</p>
                          EHF faktura:
                          <p>{{ order.customer_company.invoice_ehf }}</p>
                        </div>

                        <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                          Faktura adresse:
                          <p>{{ order.customer_company.invoice_address }}</p>
                        </div>

                        <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                          Postnummer:
                          <p>{{ order.customer_company.invoice_postcode }}</p>
                        </div>

                        <div v-if="
                          order.customer_company.invoice_method == 'invoice'
                        ">
                          Poststed:
                          <p>{{ order.customer_company.invoice_city }}</p>
                        </div> 

                        
                        <div>
                          Fakturastatus:
                          <p>{{ order.invoice_status }}</p>
                        </div> 

                       <div v-if="user && user.role && user.role.name == 'Administrator' && order.type == 'Avlusning'">
                        <hr>

                        Avtale type:
                        <b-form-select class="mb-3" v-model="order.agreement_type" :options="optionsInvoiceAgreement">
                        </b-form-select>

                        
                        Total biomasse utført:
                        <p>
                           <b-input-group class="mb-3">
                            <b-input type="number" v-model="order.details.biomass_total"></b-input>
                            <b-input-group-append>
                             
                             <b-button @click="getFLSBiomass()" variant="outline-primary">Hent fra FLS</b-button>
                            </b-input-group-append>

                          </b-input-group>
                        </p>

                        <div v-if="order.agreement_type == 'Pris pr. kg'">

                          Avtalt pris pr kg.:
                          <b-input class="mb-3" type="number" step="0.1" v-model="order.agreement_price"></b-input>
                        </div>

                        <div v-if="order.agreement_type == 'Avtale' || order.agreement_type == 'Fastpris'">
                          Pris:
                          <b-input class="mb-3" type="number" step="1" v-model="order.invoice_fixedprice"></b-input>
                        </div>

                          <b-button @click="calculateInvoice()" variant="primary">Kalkuler sum</b-button>
                        </div>                        

                        <hr>

                        Godkjent av:
                        <b-form-input class="mb-3" v-model="order.invoice_accepted_by" placeholder="Godkjent av">
                        </b-form-input>

                        Dato:
                        <datepicker class="mb-3" v-model="order.invoice_accepted_date" :format="customFormatter"
                          :bootstrap-styling="true" :disabled-dates="disabledDates"></datepicker>

                        <b-form-textarea class="mb-3" v-model="order.invoice_note" placeholder="Notat" rows="3"
                          max-rows="6"></b-form-textarea>

                         <b-form-checkbox
                            v-model="order.invoice_status"
                            value="Fakturert"
                            unchecked-value="Utkast"
                          >
                            Fakturert
                          </b-form-checkbox>

                        <br>

                        <b-button variant="primary" @click="updateOrder()">Lagre</b-button>

                      </b-card>

                    </b-col>

                    <!-- Order details -->

                    <b-col md="9">

                      <b-row>

                        <b-col md="6">

                          <b-card class="mb-3">

                            <h6>Ordre</h6>

                            Ordrenummer:
                            <p>
                              {{ order.ordernumber }}

                            </p>


                            Type:
                            <p>
                              {{ order.type}}

                            </p>


                            Fartøy:
                            <p v-if="order.vessel != null">
                              {{ order.vessel.name }}
                            </p>

                            Lokasjon:
                            <p>
                              {{ order.site.number }} - {{ order.site.name }}

                            </p>

                          </b-card>

                        </b-col>


                        <b-col md="6">

                          <b-card class="mb-3">
                            <h6>Kunde</h6>

                            Kundenavn:
                            <p>
                              {{ order.customer_company?.name || 'Ukjent kunde' }}

                            </p>

                            Kundens referanse:
                            <p>
                              {{ order.customer_ref }}

                            </p>

                            Kontaktperson:
                            <p>
                              {{ order.customer_company.contact }}

                            </p>

                          </b-card>



                        </b-col>

                      </b-row>



                      <!-- Delousing -->
                      <b-card class="mb-3" v-if="order.type == 'Avlusning'">
                        <h6>Avlusning</h6>

                        <div>

                          <b-row>

                            <b-col>
                              Avtale:
                              <p> {{ order.agreement_type }} </p>
                            </b-col>

                            <b-col>
                              Total biomasse utført:
                              <p>
                                {{ order.details.biomass_total  | numeralFormat("0,0[.]00 kg")  }} kg</p>
                            </b-col>

                            <b-col v-if="order.agreement_type == 'Pris pr. kg'">
                              Avtalt pris pr kg.:
                              <p> {{ order.agreement_price }}</p>
                            </b-col>

                            <b-col v-if="order.agreement_type != 'Pris pr. kg'">
                              
                            </b-col>

                            <b-col v-if="order.agreement_type == 'Pris pr. kg'">
                              Biomasse til fakturering:
                              <p> kr {{ order.invoice_biomass  | numeralFormat() }},-  </p>
                            </b-col>

                             <b-col v-if="order.agreement_type != 'Pris pr. kg'">
                             <span v-if="order.agreement_type == 'Fastpris'">Fastpris til fakturering:</span> 
                             <span v-if="order.agreement_type == 'Avtale'">Avtale til fakturering:</span>
                              <p>
                                kr {{ order.invoice_fixedprice | numeralFormat() 
                              }},-

                              </p>

                            </b-col>

                          </b-row>
                        </div>

                      </b-card>

                      <!-- Worklog -->
                      <b-card class="mb-3">
                        <h6>Arbeidslogg</h6>
                        <b-table caption-top striped :items="this.order.worklogs" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :fields="worklogsInvoiceFields">

                          <template v-slot:cell(from)="data">{{
                              $date(data.value).format("DD.MM.YYYY HH:mm")
                            }}</template>

                          <template v-slot:cell(to)="data">{{
                              $date(data.value).format("DD.MM.YYYY HH:mm")
                            }}</template>

                          <template v-slot:cell(duration)="data"><span v-if="data.item.billtype == 'Timepris'">{{ data.value }} timer <span
                              v-if="data.item.rate != null">x {{ data.item.rate }},-</span> </span></template>

                          <template v-slot:cell(total)="data">{{ data.item.total | numeralFormat() }},-</template>

                          <template v-slot:cell(billable)="data">
                            <span class="dot text-centre" v-if="data.item.billable == true"></span>
                          </template>

                          <template #cell(actions)="row">

                            <b-button variant="primary" class="mr-1 float-center" size="sm"
                              @click="editWorklogModal(row.item)">
                              Rediger</b-button>
                          </template>

                        </b-table>

                        <hr>

                        <b-row>

                          <b-col></b-col>
                          <b-col></b-col>

                          <b-col>

                            Timer:
                            <p>{{worklogSumHoursBillable}} timer</p>

                          </b-col>

                          <b-col>
                            Timer til fakturering:
                            <p>
                              kr {{ order.invoice_hours | numeralFormat() 
                              }},-

                            </p>

                          </b-col>

                        </b-row>

                        <hr>

                        <!-- Invoice Total -->

                        <b-row>

                          <b-col></b-col>
                          <b-col></b-col>
                          <b-col></b-col>

                          <b-col>
                            Sum totalt:
                            <h4 style="text-decoration: underline;">
                              kr {{ this.order.invoice_total | numeralFormat() 
                              }},-

                            </h4>
                          </b-col>

                        </b-row>

                      </b-card>

                    </b-col>

                  </b-row>

                </b-card-text>
              </b-tab>


              <!-- Reports -->

              <b-tab title="Sluttrapport">

                <b-row>

                  <b-col md="3">
                    <b-card bg-variant="light">

                      <h6>Sluttrapport</h6>
                      <b-form-checkbox v-model="report.declaration" value="true" unchecked-value="false">Egenerklæring
                      </b-form-checkbox>
                      <b-form-checkbox v-model="report.worklog" value="true" unchecked-value="false">Arbeidslogg
                      </b-form-checkbox>

                      <b-form-checkbox v-if="order.type == 'Avlusning'" v-model="report.fls" value="true"
                        unchecked-value="false">Spylelogg
                      </b-form-checkbox>

                      <b-button class="mt-3" variant="primary" @click="generateReport()">Last ned PDF</b-button>
                    </b-card>

                  </b-col>

                  <b-col md="9">
                    <b-card>

                      <vue-html2pdf
                      :show-layout="false"
                      :float-layout="false"
                      :enable-download="true"
                      :preview-modal="true"
                      :filename="`${order.ordernumber} - ${(order.customer_company && order.customer_company.name) || 'Ukjent kunde'} (${(order.site && order.site.name) || ''})`"
                      :manual-pagination="true"
                      pdf-format="a4"
                      pdf-content-width="100%"
                      :pdf-options="pdfOptions"
                      @progress="onProgress($event)"
                      @hasStartedGeneration="hasStartedGeneration()"
                      @hasGenerated="hasGenerated($event)"
                      ref="html2Pdf"
                    >
                      <!-- this slot is what will be rendered into the PDF -->
                      <section slot="pdf-content" class="pdf-document">

                        <!-- Header -->
                        <div class="pdf-header">
                          <div>
                            <h3>Eines AS</h3>
                            <h5>Rapport</h5>
                          </div>
                          <div class="order-info">
                            <h2>Ordre #{{ order.ordernumber }}</h2>
                            <p>Dato: {{ $date(order.createdAt).format("DD.MM.YYYY") }}</p>
                            <p>Kunde: <strong>{{ (order.customer_company && order.customer_company.name) || 'Ukjent kunde' }}</strong></p>
                            <p>Lokasjon: <strong>{{ (order.site && order.site.name) || '' }}</strong></p>
                          </div>
                        </div>

                        <!-- Summary -->
                        <table class="summary-table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Varighet</th>
                              <th>Dager</th>
                              <th>Arbeidstimer</th>
                              <th>Tillegg</th>
                              <th>Totalt</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ order.type }}</td>
                              <td>
                                {{ $date(order.startdate).format("DD.MM.YYYY") }}
                                – {{ $date(order.enddate).format("DD.MM.YYYY") }}
                              </td>
                              <td>
                                {{ order.startdate !== order.enddate
                                  ? $date(order.enddate).diff(order.startdate, "days")
                                  : 1 }}
                              </td>
                              <td>{{ order.invoice_hours | numeralFormat("0,0[.]") }},-</td>
                              <td>{{ order.invoice_biomass | numeralFormat("0,0[.]") }},-</td>
                              <td>{{ order.invoice_total | numeralFormat("0,0[.]") }},-</td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- Kontaktopplysninger (stays on page 1) -->
                        <div class="section-title">Kontaktopplysninger</div>
                        <table class="info-table">
                          <tr>
                            <td class="label">Leverandør</td>
                            <td>
                              {{ (order.supplier_company && order.supplier_company.name) || '' }}<br/>
                              <span v-if="order.supplier_company && order.supplier_company.contact">{{ order.supplier_company.contact }}</span><br/>
                              <span v-if="order.supplier_company && order.supplier_company.email">{{ order.supplier_company.email }}</span><br/>
                              <span v-if="order.supplier_company && order.supplier_company.phone">{{ order.supplier_company.phone }}</span>
                            </td>
                            <td class="label">Bestiller</td>
                            <td>
                              {{ (order.customer_company && order.customer_company.name) || '' }}<br/>
                              <span v-if="order.customer_company && order.customer_company.contact">{{ order.customer_company.contact }}</span><br/>
                              <span v-if="order.customer_company && order.customer_company.email">{{ order.customer_company.email }}</span><br/>
                              <span v-if="order.customer_company && order.customer_company.phone">{{ order.customer_company.phone }}</span>
                            </td>
                          </tr>
                        </table>

                        <!-- Fartøy & Lokasjon (still page 1) -->
                        <div class="section-title">Fartøy & Lokasjon</div>
                        <table class="info-table">
                          <tr>
                            <td class="label">Fartøy</td>
                            <td>{{ (order.vessel && order.vessel.name) || '–' }}</td>
                            <td class="label">Skipper</td>
                            <td>{{ (order.captain && order.captain.name) || '–' }}</td>
                          </tr>
                          <tr>
                            <td class="label">Lokasjon</td>
                            <td colspan="3">{{ (order.site && order.site.number) || '' }} – {{ (order.site && order.site.name) || '' }}</td>
                          </tr>
                        </table>

                        <!-- Egenerklæring (forced onto page 2) -->
                        <div
                          v-if="report.declaration"
                          class="section-title declaration"
                        >
                          Egenerklæring
                        </div>
                        <div
                          v-if="report.declaration"
                          class="declaration-section"
                        >
                          <ol>
                            <li>
                              Inntaksrør, fiskepumper, silkasser<span v-if="order.type == 'Avlusning'">, FLS-spyler</span><br/>
                              <small>Pålegges med høytrykksvasker, krypdyse, innvendig i rør og pumper. Preparat Salardes 1,5 %</small>
                            </li>
                            <li v-if="order.type != 'Brønnbåt'">
                              Lusefilter<br/>
                              <small>Spyles med brannslange, legges i et kar med desinfeksjon. Preparat Salardes 1,5 %</small>
                            </li>
                            <li>
                              Utvendig: dekk, kran, styrehus<span v-if="order.type == 'Avlusning'">, FLS-spyler utvendig,</span> skutesider<br/>
                              <small>Pålegges med høytrykksvasker. Preparat Salardes 1,5 %</small>
                            </li>
                            <li>
                              Løfteredskap, løftestropper, diverse løse ting på dekk<br/>
                              <small>Pålegges med høytrykksvasker som skum eller med pumpekanne. Preparat Salardes 1,5 %</small>
                            </li>
                            <li>Tauverk og fortøyningsutstyr</li>
                            <li>
                              Innvendig: styrehus og oppholdsrom<br/>
                              <small>Med bøtte og klut. Preparat Såpe</small>
                            </li>
                            <li>
                              Arbeidstøy<br/>
                              <small>Oljeklær og hansker skylles rene. Alle klær vaskes i vaskemaskin på egnet program. Preparat Såpe</small>
                            </li>
                            <li>
                              Hender<br/>
                              <small>Håndvask. Preparat Såpe</small>
                            </li>
                          </ol>
                          <div class="declaration-completion">
                            <p><strong>Fullført:</strong> {{ $date(declaration.completed_date).format("DD.MM.YYYY") }}</p>
                            <p><strong>Godkjent av:</strong> {{ declaration.accepted_by }}</p>
                            <p><strong>Godkjent dato:</strong> {{ $date(declaration.accepted_date).format("DD.MM.YYYY") }}</p>
                          </div>
                        </div>

                        <!-- Arbeidslogg (forced onto page 3) -->
                        <div v-if="report.worklog" class="section-title section-break worklog">
                          Arbeidslogg
                        </div>
                        <b-table
                          v-if="report.worklog"
                          small
                          class="pdf-table"
                          :items="order.worklogs"
                          :fields="worklogsReportFields"
                          caption-top
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                        >
                          <template #table-caption>Totalt: {{ worklogSumHours }} timer</template>
                          <template #cell(from)="d">{{ $date(d.value).format("DD.MM.YYYY HH:mm") }}</template>
                          <template #cell(to)="d">{{ $date(d.value).format("DD.MM.YYYY HH:mm") }}</template>
                          <template #cell(duration)="d">{{ d.value }} timer</template>
                        </b-table>

                        <!-- Spylelogg continues on page 3 -->
                        <div v-if="report.fls && order.type === 'Avlusning'" class="section-title">
                          Spylelogg
                        </div>
                        <b-table
                          v-if="report.fls && order.type === 'Avlusning'"
                          small
                          class="pdf-table"
                          :items="order.fls"
                          :fields="flsReportFields"
                          empty-text="Ingen data tilgjengelig"
                        >
                          <template #cell(regtime)="d">{{ $date(d.value).format("DD.MM.YYYY HH:mm") }}</template>
                          <template #cell(cage)="d">
                            {{ d.item.from_cage }}<span v-if="d.item.to_cage">– {{ d.item.to_cage }}</span>
                          </template>
                          <template #cell(biomass)="d">{{ d.value | numeralFormat("0,0[.]00") }} kg</template>
                        </b-table>

                      </section>
                    </vue-html2pdf>

                    </b-card>

                  </b-col>

                </b-row>


              </b-tab>

              <!-- Reports (Rapportmaler) -->

              <b-tab title="Rapporter" lazy>
                <order-reports :order="order" />
              </b-tab>

              <!-- Attachments -->

              <b-tab :title='"Vedlegg (" + order.attachments.length + ")"'>

                <b-row>

                  <b-col md="3">
                    <b-card bg-variant="light">
                      <h6>Last opp vedlegg</h6>

                      <b-form-file v-model="selectedFile" browse-text="Velg" placeholder="Ingen fil valgt"
                        drop-placeholder="Dra og slipp fil her"></b-form-file>

                      <br>
                      <b-button v-if="selectedFile == null" variant="outline-primary" disabled>Last
                        opp</b-button>
                      <b-button v-if="selectedFile != null" variant="primary" @click="onUpload()">Last opp</b-button>
                    </b-card>

                  </b-col>

                  <b-col md="9">

                    <b-card>
                      <h6>Vedlegg</h6>

                      <b-table striped hover :items="order.attachments" :fields="fieldsUpload">
                        <template v-slot:cell(name)="data">
                          <b-link :href="data.item.url" target="_blank">{{data.item.name}} </b-link>
                        </template>

                        <template v-slot:cell(size)="data">
                          {{data.item.size * 1000 | prettyBytes('MB')}}
                        </template>

                        <template v-slot:cell(createdAt)="data">
                          {{  $date(data.value).format("DD.MM.YYYY HH:mm")}}
                        </template>

                        <template v-slot:cell(remove)="data">
                         <b-button size="sm" variant="primary" @click="deleteUpload(data.item)">Fjern</b-button>
                        </template>

                      </b-table>

                      <!-- Modal - Confirm delete file -->



                    </b-card>

                  </b-col>

                </b-row>

              </b-tab>

            </b-tabs>
          </b-card>

      </b-col>
    </b-row>
  </div>

</template>

<script>
  import axios from "axios";
  
  import Vue2Filters from "vue2-filters";
  import VueMoment from "vue-moment";
  import moment from "moment";
  import dayjs from "dayjs";
  
  import Datepicker from 'vuejs-datepicker'
  import { BFormTimepicker } from 'bootstrap-vue'
  import {
    debounce
  } from "lodash";
  import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
  import OrderReports from "@/components/rapporter/OrderReports";
  import { VueOfflineStorage } from 'vue-offline';

  import {
    LMap,
    LTileLayer,
    LMarker,
    LControlLayers,
    LControl,
    LCircle,
    LPopup,
    LPolyline,
    LLayerGroup,
    LTooltip,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LIcon,
  } from "vue2-leaflet";

  

  import {
    Icon
  } from "leaflet";
  delete Icon.Default.prototype._getIconUrl;

  Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });

  const OFFLINE_FLS_KEY_PREFIX = 'order-fls-drafts-';
const OFFLINE_WORKLOG_KEY_PREFIX = 'order-worklog-drafts-';
const OFFLINE_ORDER_SNAPSHOT_PREFIX = 'order-snapshot-';

export default {
    components: {
      
      LMap,
      LTileLayer,
      LMarker,
      LControlLayers,
      LControl,
      LPopup,
      LCircle,
      LPolyline,
      LLayerGroup,
      LTooltip,
      LControlZoom,
      LControlAttribution,
      LControlScale,
      LIcon,
      VueMoment,
      moment,
      
      Datepicker,
      BFormTimepicker,
      VueTypeaheadBootstrap,
      VueOfflineStorage,
      OrderReports,
    },
    mixins: [Vue2Filters.mixin],
    data() {
      return {
        user: {},
        order: {
          agreement_type: "Avtale",
          agreement_price: 0,
          invoice_status: "Utkast",
          invoice_hours: 0,
          invoice_biomass: 0,
          invoice_total: 0,
          settings: {},
          details: {
            biomass_ordered: 0,
            biomass_total: 0,
            cages: [],
            servicework: [],
            destination: {
              approval: '',
              name: ''
            },
            transport: "to_location",
            fishcount: 0,
        },
        },
        destination: {},
        companies: [],
        factories: [],
        site: {},
        sites: [],
        cage: {},
        unloadingCage: {},
        fls: {
          lines: 1,
          data: {},
        },
        editfls: {},
        vessel: {
          fls: {},
        },
        worklog: {
          action: "Reise",
          duration: 0,
          rate: 0,
          total: 0,
          billable: true,
          billtype: "Timepris"
        },
        editworklog: {},
        worklogs: [],
        offlineFlsDrafts: [],
        offlineWorklogDrafts: [],
        isUploadingOfflineFls: false,
        isUploadingOfflineWorklog: false,
        offlineFlsError: null,
        offlineWorklogError: null,
        offlineFlsDraftFields: [
          { key: "regtime", label: "Tidspunkt" },
          { key: "from_cage", label: "Fra merd" },
          { key: "to_cage", label: "Til merd" },
          { key: "biomass", label: "Biomasse (kg)" },
          { key: "comment", label: "Kommentar" },
          { key: "actions", label: "" },
        ],
        offlineWorklogDraftFields: [
          { key: "action", label: "Hendelse" },
          { key: "from", label: "Fra" },
          { key: "to", label: "Til" },
          { key: "duration", label: "Timer" },
          { key: "description", label: "Beskrivelse" },
          { key: "actions", label: "" },
        ],
        declaration: {
          details: {},
        },
        declarations: [],
        licecount: [],
        report: {
          fls: true,
          worklog: true,
          declaration: true,
        },
        captain: {},
        captainSelect: [],
        selectedFile: null,
        queryCompany: "",
        queryFactories: null,
        querySites: null,
        querySitesTransport: null,
        fls_lastupdate: null,
        fls_settingsupdate: null,
        vesselSelect: [],
        worklogDuration: 0,
        worklogDurationCal: 0,
        worklogSumHours: 0,
        worklogSumHoursBillable: 0,
        flsSumFish: 0,
        flsSumBiomass: 0,
        order: {},
        trips: [],
        tripFields: [
          { key: 'tripNumber', label: 'Tur nr.' },
          { key: 'vessel', label: 'Fartøy' },
          { key: 'location', label: 'Lokasjon' },
          { key: 'loading.startDate', label: 'Start lasting' },
          { key: 'loading.endDate', label: 'Slutt lasting' },
          { key: 'unloading.endDate', label: 'Avsluttet Lossing ' },
          { key: 'actions', label: '' }
        ],
        tripCageFields: [{
            key: "cages",
            label: "Merd",
            sortable: true,
          },
          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: true,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },

          {
            key: "biomass",
            label: "Biomasse (kg)",
            sortable: true,
          },
          {
            key: "actions",
            label: "",
            sortable: false,
          },
        ],
        tripUnloadingCageFields: [{
            key: "cages",
            label: "Merd",
            sortable: true,
          },
          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: true,
          },
          {
            key: "cageaverageweight",
            label: "Snittvekt",
            sortable: true,
          },
          {
            key: "biomass",
            label: "Biomasse (kg)",
            sortable: true,
          },
          {
            key: "actions",
            label: "",
            sortable: false,
          },
        ],
        trip: this.emptyTrip(),
        cageFields: [{
            key: "cages",
            label: "Merder",
            sortable: true,
          },
          {
            key: "biomass",
            label: "Biomasse (kg)",
            sortable: true,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },
          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: true,
          },
          {
            key: "note",
            label: "Notat",
            sortable: false,
            tdClass: "notemaxwidth",
          },
          {
            key: "actions",
            label: "",
            sortable: false,
          },
        ],
        isEditing: false,
        tripModalTitle: '',
        showEditDetails: false,
        showContacts: false,
        confirmation: false,
        sortBy: 'from',
        sortDesc: false,
        fullPage: true,
        isLoading: false,
        orderStatusAdmin: [{
            value: "Bestilling",
            text: "Bestilling",
          },
          {
            value: "Ordre",
            text: "Ordre",
          },
          {
            value: "I arbeid",
            text: "I arbeid",
          },
          {
            value: "Arbeid avsluttet",
            text: "Arbeid avsluttet",
          },
          {
            value: "Til fakturering",
            text: "Til fakturering",
          },
          {
            value: "Fakturert",
            text: "Fakturert",
          },
          {
            value: "Kansellert",
            text: "Kansellert",
          },
        ],
        orderStatus: [
          {
            value: "Ordre",
            text: "Ordre",
          },
          {
            value: "I arbeid",
            text: "I arbeid",
          },
          {
            value: "Arbeid avsluttet",
            text: "Arbeid avsluttet",
          },
        ],
        orderType: [{
            value: "Avlusning",
            text: "Avlusning",
          },
          {
            value: "Notspyling",
            text: "Notspyling",
          },
          {
            value: "Servicearbeid",
            text: "Servicearbeid",
          },
          {
            value: "Brønnbåt",
            text: "Brønnbåt",
          },
        ],
        serviceOptions: [{
            text: "Notskifte",
            value: "Notskifte",
          },
          {
            text: "Luseskjørt fjerning/setting",
            value: "Luseskjørt fjerning/setting",
          },
          {
            text: "Fuglenett fjerning/setting",
            value: "Fuglenett fjerning/setting",
          },
          {
            text: "Lippfisk skjul",
            value: "Lippfisk skjul",
          },
          {
            text: "Fortøyningsarbeid",
            value: "Fortøyningsarbeid",
          },
          {
            text: "ROV inspeksjon",
            value: "ROV inspeksjon",
          },
          {
            text: "Annet",
            value: "Annet",
          },
        ],
        wellboatSpecies: [{
            value: "Laks - Slaktefisk",
            text: "Laks - Slaktefisk"
          },
          {
            value: "Laks - Smolt",
            text: "Laks - Smolt"
          },
          {
            value: "Laks - Stamfisk",
            text: "Laks - Stamfisk"
          },
          {
            value: "Torsk",
            text: "Torsk"
          },
        ],
        invoiceStatus: [{
            value: "Utkast",
            text: "Utkast",
          },
          {
            value: "Send til fakturering",
            text: "Send til fakturering",
          },
          {
            value: "Til fakturering",
            text: "Til fakturering",
          },
          {
            value: "Ferdig fakturert",
            text: "Ferdig fakturert",
          },
        ],
        speciesOptions: [{
            text: "Laks",
            value: "Laks",
          },
          {
            text: "Regnbueørret",
            value: "Regnbueørret",
          },
          {
            text: "Torsk",
            value: "Torsk",
          },
          {
            text: "Røye",
            value: "Røye",
          },
          {
            text: "Kveite",
            value: "Kveite",
          },

        ],
        cageFields: [{
            key: "cages",
            label: "Merder",
            sortable: true,
          },

          {
            key: "biomass",
            label: "Biomasse (kg)",
            sortable: false,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },
          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: true,
          },
          {
            key: "note",
            label: "Notat",
            tdClass: "notemaxwidth",
          },
          {
            key: "actions",
            label: "Handlinger",
          },
        ],
        cageFlushFields: [{
            key: "number",
            label: "Merdnummer",
            sortable: true,
          },
          {
            key: "type",
            label: "Type",
            sortable: false,
          },
          {
            key: "averageweight",
            label: "Snittvekt",
            sortable: true,
          },
        ],
        worklogsFields: [{
            key: "action",
            label: "Hendelse",
            sortable: true,
          },

          {
            key: "from",
            label: "Fra",
            sortable: true,
          },

          {
            key: "to",
            label: "Til",
            sortable: false,
          },
          {
            key: "billtype",
            label: "Type",
            sortable: false,
          },
          {
            key: "duration",
            label: "Antall timer",
            sortable: false,
          },

          {
            key: "description",
            label: "Beskrivelse",
            sortable: false,
            tdClass: "worklogmaxwidth",
          },

          {
            key: "actions",
            label: "Handlinger",
            sortable: false,
          },
        ],
        worklogsInvoiceFields: [{
            key: "billable",
            label: "Fakturer",
            sortable: true,
          },
          {
            key: "action",
            label: "Hendelse",
            sortable: true,
          },
          {
            key: "description",
            label: "Beskrivelse",
            sortable: false,
            tdClass: "worklogmaxwidth",
          },
          {
            key: "billtype",
            label: "Type",
            sortable: false,
          },
          {
            key: "duration",
            label: "Antall timer",
            sortable: false,
          },
          {
            key: "total",
            label: "Totalt",
            sortable: false,
          },
          {
            key: "actions",
            label: "Handlinger",
            sortable: false,
          },
        ],
        worklogsReportFields: [{
            key: "action",
            label: "Hendelse",
          },

          {
            key: "from",
            label: "Fra",
          },

          {
            key: "to",
            label: "Til",
          },
          {
            key: "duration",
            label: "Antall timer",
          },
          {
            key: "description",
            label: "Beskrivelse",
            tdClass: "worklogmaxwidth",
          },
        ],
        flsReportFields: [{
            key: "regtime",
            label: "Tidspunkt",

          },
          {
            key: "cage",
            label: "Merder",

          },

          {
            key: "ejector",
            label: "Ejektor",

          },
          {
            key: "flushpressure",
            label: "Spyletrykk",

          },
          {
            key: "oxygen",
            label: "Oksygen",

          },
          {
            key: "fishcount",
            label: "Antall fisk",

          },
          {
            key: "biomass",
            label: "Biomasse",

          },
          {
            key: "comment",
            label: "Kommentar",

            tdClass: "flscellmaxwidth",
          },

        ],
        licecountFields: [
          { key: "week", label: "Uke", sortable: true },
          { key: "type", label: "Type", sortable: true },
          { key: "cage", label: "Merd", sortable: true },          
          { key: "fishcount", label: "Antall fisk", sortable: true },
          { key: "lice_female", label: "Hunnlus", sortable: true },
          { key: "lice_moving", label: "Bevegelige", sortable: true },
          { key: "lice_persist", label: "Fastsittende", sortable: true },
          { key: "createdAt", label: "Opprettet", sortable: true },
          { key: "actions", label: "" },
        ],
        flsFields: [{
            key: "regtime",
            label: "Tidspunkt",
            sortable: true,
          },
          {
            key: "cage",
            label: "Merder",
            sortable: true,
          },

          {
            key: "ejector",
            label: "Ejektor",
            sortable: true,
          },
          {
            key: "flushpressure",
            label: "Spyletrykk",
            sortable: false,
          },
          {
            key: "oxygen",
            label: "Oksygen",
            sortable: false,
          },
          {
            key: "fishcount",
            label: "Antall fisk",
            sortable: false,
          },
          {
            key: "biomass",
            label: "Biomasse",
            sortable: false,
          },
          {
            key: "comment",
            label: "Kommentar",
            sortable: false,
            tdClass: "flscellmaxwidth",
          },

          {
            key: "actions",
            label: "Handlinger",
            sortable: false,
          },
        ],
        worklogOptions: [{
            text: "Reise",
            value: "Reise"
          },
          {
            text: "Vent",
            value: "Vent"
          },
          {
            text: "Klargjøring",
            value: "Klargjøring",
          },
          {
            text: "Opprigg",
            value: "Opprigg",
          },
          {
            text: "Nedrigg",
            value: "Nedrigg",
          },
          {
            text: "Lasting",
            value: "Lasting",
          },
          {
            text: "Lossing",
            value: "Lossing",
          },
          {
            text: "Avlusning",
            value: "Avlusning",
          },
          {
            text: "Servicearbeid",
            value: "Servicearbeid",
          },

          {
            text: "Vasking",
            value: "Vasking",
          },
          {
            text: "Desinfeksjon",
            value: "Desinfeksjon",
          },
          {
            text: "Veterinær",
            value: "Veterinær",
          }
        ],
        billableOptions: [{
            value: true,
            text: "Fakturer"
          },
          {
            value: false,
            text: "Ikke fakturer"
          },
        ],
        billtypeOptions: [{
            value: "Timepris",
            text: "Timepris"
          },
          {
            value: "Fastpris",
            text: "Fastpris"
          },
        ],
        optionsInvoiceAgreement: [{
            value: "Pris pr. kg",
            text: "Pris pr. kg"
          },
          {
            value: "Fastpris",
            text: "Fastpris"
          },
          {
            value: "Avtale",
            text: "Avtale"
          },
        ],
        flsLinesOptions: [{
            value: 1,
            text: "1 Linje",
          },
          {
            value: 2,
            text: "2 Linjer",
          },
          {
            value: 3,
            text: "3 Linjer",
          },
          {
            value: 4,
            text: "4 Linjer",
          },
        ],
        fieldsDeclarations: [{
            key: "ordertitle",
            label: "Ordre",
            sortable: true
          },
          {
            key: "vessel",
            label: "Fartøy",
            sortable: true
          },
          {
            key: "completed_date",
            label: "Fullført",
            sortable: true
          },
          {
            key: "accepted_by",
            label: "Godkjent av",
            sortable: true
          },
          {
            key: "accepted_date",
            label: "Godkjent dato",
            sortable: true
          },
        ],
        fieldsUpload: [{
            key: "name",
            label: "Filnavn",
            sortable: true
          },
          {
            key: "size",
            label: "Størrelse",
            sortable: true
          },
          {
            key: "createdAt",
            label: "Opprettet",
            sortable: true
          },
          {
            key: "remove",
            label: "",
            sortable: true
          },
        ],
        wellboatTransport: [{
            value: "to_location",
            text: "Fra lokasjon til lokasjon"
          },
          {
            value: "to_factory",
            text: "Fra lokasjon til fabrikk"
          },
        ],
        wellOptions : [{
            value: "BB",
            text: "BB"
          },
          {
            value: "STB",
            text: "STB"
          }, 
          {
            value: "Midt",
            text: "Midt"
          }
        ],
        fieldsTrip: [{
            key: "tripNumber",
            label: "Tur nr.",
            sortable: true
          },
          {
            key: "vessel",
            label: "Fartøy",
            sortable: true
          },
          {
            key: "location",
            label: "Lokasjon",
            sortable: true
          },
          {
            key: "loading.startDate",
            label: "Start lasting",
            sortable: true
          },
          {
            key: "loading.endDate",
            label: "Slutt lasting"
        }],
        pdfOptions: {
          margin: [10, 10, 10, 10],            // 10 mm padding
          pagebreak: {
            before: [
              '.section-title.declaration',    // break before Egenerklæring
              '.section-title.worklog'         // break before Arbeidslogg
            ]
          }
        },
        zoom: 10,
        url: "https://api.mapbox.com/styles/v1/packtracker-com/ck8d9hr3y1adz1io2kctelu2y/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGFja3RyYWNrZXItY29tIiwiYSI6ImNrOGM1ZWYwZTBmdjAzZWthNTFjdXA1c3cifQ.V_peofXp-4LxUrosRdD9jA",
        attribution: '<a href="https://www.eines-as.no">Eines AS</a>',
        circle: {
          radius: 2,
          color: "#022D56",
        },

        circleVessel: {
          radius: 1,
          color: "#025D46",
        },
        max: 5,
      };
    },
    // A prop is a custom attribute for passing information to a component
    props: ["id"],

    // Check if user is logged in
    computed: {
      // Crew on planned orders is set by the Mannskapsplanlegger (until locked or finished).
      crewFromPlanner() {
        const done = ['Kansellert', 'Arbeid avsluttet', 'Utført', 'Til fakturering', 'Send til fakturering', 'Klar til fakturering', 'Fakturert', 'Avsluttet'];
        return !!(this.order && this.order.skift && !this.order.crew_locked && !done.includes(this.order.status));
      },
      $isOnline() {
        // Check if vue-offline plugin is available
        if (this.$store && this.$store.getters && this.$store.getters.isOnline !== undefined) {
          return this.$store.getters.isOnline;
        }
        // Fallback to navigator.onLine
        return navigator.onLine;
      },
      isLoggedIn: function () {
        return this.$store.getters.isLoggedIn;
      },
      hasOfflineFlsDrafts: function () {
        return this.offlineFlsDrafts.length > 0;
      },
      hasOfflineWorklogDrafts: function () {
        return this.offlineWorklogDrafts.length > 0;
      },
      offlineFlsTableItems: function () {
        return this.offlineFlsDrafts.map((draft) => ({
          id: draft.id,
          regtime: draft.payload.regtime,
          from_cage: draft.payload.from_cage,
          to_cage: draft.payload.to_cage,
          biomass: draft.payload.biomass,
          comment: draft.payload.comment,
        }));
      },
      offlineWorklogTableItems: function () {
        return this.offlineWorklogDrafts.map((draft) => ({
          id: draft.id,
          action: draft.payload.action,
          from: draft.payload.from,
          to: draft.payload.to,
          duration: draft.payload.duration,
          description: draft.payload.description,
        }));
      },
    },
    // We use computed properties based on 'props' to avoid any complex logic in our template
    watch: {
      $isOnline: function (status) {
        if (status) {
          this.onConnectionRestored();
        } else {
          this.syncOfflineFlags();
        }
      },
      // whenever question changes, this function will run
      vessel: function () {
        this.order.vessel = this.vessel;
      },
      captain: function () {
        this.order.captain = this.captain;
      },
      worklog: function () {
        this.worklog.duration = null;
        this.$forceUpdate();

        var start = moment(
          this.worklog.startdate + ", " + this.worklog.fromtime
        ).locale("no");

        var end = moment(
          this.worklog.enddate + ", " + this.worklog.totime
        ).locale("no");

        var durationWorklog = moment(end).diff(start, "minutes") / 60;

        var durationWorklogCal = Math.round(durationWorklog / 0.5) * 0.5;

        this.worklog.duration = durationWorklogCal;
      },
    },
    methods: {
      // Brønnbåt has no lice filter, so the Egenerklæring skips item 2 and renumbers the rest.
      declarationNo(n) {
        return this.order.type == 'Brønnbåt' && n > 2 ? n - 1 : n;
      },
      openOfflineEditor() {
        const targetId = (this.order && this.order.id) || this.id;
        if (targetId) {
          this.$router.push({ name: "order-edit-offline", params: { id: targetId } });
        }
      },
      syncOfflineFlags() {
        this.loadOfflineDrafts();
        if (!this.$isOnline) {
          const snapshot = this.loadOfflineOrderSnapshot();
          if (snapshot) {
            if (!this.order || this.order.id !== snapshot.id || this.offlineOrderUnavailable) {
              this.applyLoadedOrder(snapshot);
            }
          } else {
            this.offlineOrderUnavailable = true;
          }
        }
      },
      onConnectionRestored() {
        this.offlineFlsError = null;
        this.offlineWorklogError = null;
        this.offlineOrderUnavailable = false;
        this.loadOfflineDrafts();
        this.getOrder();
        this.getUser();
        this.getFactories();
      },
      getOfflineFlsKey() {
        const orderId = (this.order && this.order.id) || this.id;
        if (!orderId) {
          return null;
        }
        return `${OFFLINE_FLS_KEY_PREFIX}${orderId}`;
      },
      getOfflineWorklogKey() {
        const orderId = (this.order && this.order.id) || this.id;
        if (!orderId) {
          return null;
        }
        return `${OFFLINE_WORKLOG_KEY_PREFIX}${orderId}`;
      },
      loadOfflineDrafts() {
        if (!this.$offlineStorage) {
          return;
        }
        const flsKey = this.getOfflineFlsKey();
        const worklogKey = this.getOfflineWorklogKey();
        
        if (!flsKey || !worklogKey) {
          return;
        }
        
        const flsDrafts = this.$offlineStorage.get(flsKey);
        const worklogDrafts = this.$offlineStorage.get(worklogKey);
        this.offlineFlsDrafts = Array.isArray(flsDrafts) ? flsDrafts : [];
        this.offlineWorklogDrafts = Array.isArray(worklogDrafts) ? worklogDrafts : [];
      },
      persistOfflineFlsDrafts() {
        if (this.$offlineStorage) {
          const flsKey = this.getOfflineFlsKey();
          if (flsKey) {
            this.$offlineStorage.set(flsKey, this.offlineFlsDrafts);
          }
        }
      },
      persistOfflineWorklogDrafts() {
        if (this.$offlineStorage) {
          const worklogKey = this.getOfflineWorklogKey();
          if (worklogKey) {
            this.$offlineStorage.set(worklogKey, this.offlineWorklogDrafts);
          }
        }
      },
      getOfflineOrderSnapshotKey() {
        const orderId = (this.order && this.order.id) || this.id;
        if (!orderId) {
          return null;
        }
        return `${OFFLINE_ORDER_SNAPSHOT_PREFIX}${orderId}`;
      },
      loadOfflineOrderSnapshot() {
        if (!this.$offlineStorage) {
          return null;
        }
        const snapshotKey = this.getOfflineOrderSnapshotKey();
        if (!snapshotKey) {
          return null;
        }
        const snapshot = this.$offlineStorage.get(snapshotKey);
        return snapshot ? JSON.parse(JSON.stringify(snapshot)) : null;
      },
      persistOfflineOrderSnapshot(order) {
        if (!this.$offlineStorage || !order || !order.id) {
          return;
        }
        this.$offlineStorage.set(this.getOfflineOrderSnapshotKey(), JSON.parse(JSON.stringify(order)));
      },
      applyLoadedOrder(order) {
        const clonedOrder = JSON.parse(JSON.stringify(order));
        this.order = clonedOrder;
        this.isLoading = false;

        this.loadOfflineDrafts();

        this.vessel = this.order.vessel || null;
        this.captain = this.order.captain || null;

        if (this.order.supplier_company && this.order.supplier_company.invoice_rate != null) {
          this.worklog.rate = this.order.supplier_company.invoice_rate;
        }

        if (this.order.fls && this.order.fls.length > 0) {
          this.order.fls = this.order.fls.sort((a, b) => new Date(b.regtime) - new Date(a.regtime));
          this.order.fls.reverse();
          const copyflsSettings = this.order.fls.slice(-1)[0];
          const flsSettings = JSON.parse(JSON.stringify(copyflsSettings));
          this.fls = flsSettings;
        }

        if (this.order.declarations && this.order.declarations.length > 0) {
          this.declaration = this.order.declarations.slice(-1)[0];
        }

        if (this.order.details && this.order.details.cages && this.order.details.cages[0] != null) {
          this.order.details.biomass_ordered = this.order.details.cages.reduce((n, { biomass }) => parseInt(n) + parseInt(biomass), 0);
        } else if (this.order.details) {
          this.order.details.biomass_ordered = 0;
        }

        if (this.order.fls && this.order.fls[0] != null) {
          this.flsSumFish = this.order.fls
            .filter(({ completed }) => completed == true)
            .reduce((n, { fishcount }) => n + fishcount, 0);

          this.flsSumBiomass = this.order.fls
            .filter(({ completed }) => completed == true)
            .reduce((n, { biomass }) => parseInt(n) + parseInt(biomass), 0);
        } else {
          this.flsSumFish = 0;
          this.flsSumBiomass = 0;
        }

        if (this.order.worklogs && this.order.worklogs[0] != null) {
          this.worklogSumHours = this.order.worklogs.reduce((n, { duration }) => n + duration, 0);
          this.worklogSumHoursBillable = this.order.worklogs
            .filter(({ billable }) => billable == true)
            .reduce((n, { duration }) => n + duration, 0);
          this.order.invoice_hours = this.order.worklogs
            .filter(({ billable }) => billable == true)
            .reduce((n, { total }) => n + total, 0);
          this.order.invoice_total = this.order.invoice_hours + this.order.invoice_biomass;
        } else {
          this.worklogSumHours = 0;
          this.worklogSumHoursBillable = 0;
        }

        if (this.$isOnline) {
          this.getVessels();
          this.getCaptain();
        }

        if (this.order.site) {
          this.querySites = this.order.site.number + ' - ' + this.order.site.name;
        }
        if (this.order.details && this.order.details.destination) {
          this.querySitesTransport = this.order.details.destination.number + ' - ' + this.order.details.destination.name;
        }

        this.offlineOrderUnavailable = false;
      },
      saveFlsDraft(flsData) {
        const draft = {
          id: `fls-draft-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
          createdAt: new Date().toISOString(),
          payload: flsData,
        };
        this.offlineFlsDrafts.push(draft);
        this.persistOfflineFlsDrafts();
        this.offlineFlsError = null;
      },
      saveWorklogDraft(worklogData) {
        const draft = {
          id: `worklog-draft-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
          createdAt: new Date().toISOString(),
          payload: worklogData,
        };
        this.offlineWorklogDrafts.push(draft);
        this.persistOfflineWorklogDrafts();
        this.offlineWorklogError = null;
      },
      removeOfflineFlsDraft(draftId) {
        this.offlineFlsDrafts = this.offlineFlsDrafts.filter((draft) => draft.id !== draftId);
        this.persistOfflineFlsDrafts();
        if (!this.offlineFlsDrafts.length) {
          this.offlineFlsError = null;
        }
      },
      removeOfflineWorklogDraft(draftId) {
        this.offlineWorklogDrafts = this.offlineWorklogDrafts.filter((draft) => draft.id !== draftId);
        this.persistOfflineWorklogDrafts();
        if (!this.offlineWorklogDrafts.length) {
          this.offlineWorklogError = null;
        }
      },
      clearOfflineFlsDrafts() {
        this.offlineFlsDrafts = [];
        this.persistOfflineFlsDrafts();
        this.offlineFlsError = null;
      },
      clearOfflineWorklogDrafts() {
        this.offlineWorklogDrafts = [];
        this.persistOfflineWorklogDrafts();
        this.offlineWorklogError = null;
      },
      async uploadOfflineFlsDrafts() {
        if (!this.hasOfflineFlsDrafts || !this.$isOnline || this.isUploadingOfflineFls) {
          return;
        }
        this.isUploadingOfflineFls = true;
        this.offlineFlsError = null;

        const draftsToUpload = [...this.offlineFlsDrafts];
        const uploaded = [];

        for (const draft of draftsToUpload) {
          try {
            const response = await axios.post("https://api.eines-as.no/fls/", draft.payload);
            this.order.fls.push(response.data);
            uploaded.push(draft.id);
          } catch (error) {
            console.log(error);
            this.offlineFlsError = "Kunne ikke laste opp alle FLS-utkast. Pr�v igjen n�r tilkoblingen er stabil.";
            break;
          }
        }

        const hadSuccessfulUploads = uploaded.length > 0;

        if (uploaded.length) {
          this.offlineFlsDrafts = this.offlineFlsDrafts.filter((draft) => !uploaded.includes(draft.id));
          this.persistOfflineFlsDrafts();
          this.fls_lastupdate = new Date();
        }

        this.isUploadingOfflineFls = false;

        if (hadSuccessfulUploads) {
          this.updateOrder();
        }
      },
      async uploadOfflineWorklogDrafts() {
        if (!this.hasOfflineWorklogDrafts || !this.$isOnline || this.isUploadingOfflineWorklog) {
          return;
        }
        this.isUploadingOfflineWorklog = true;
        this.offlineWorklogError = null;

        const draftsToUpload = [...this.offlineWorklogDrafts];
        const uploaded = [];

        for (const draft of draftsToUpload) {
          try {
            const response = await axios.post("https://api.eines-as.no/worklogs/", draft.payload);
            this.order.worklogs.push(response.data);
            uploaded.push(draft.id);
          } catch (error) {
            console.log(error);
            this.offlineWorklogError = "Kunne ikke laste opp alle arbeidslogg-utkast. Pr�v igjen n�r tilkoblingen er stabil.";
            break;
          }
        }

        const hadSuccessfulUploads = uploaded.length > 0;

        if (uploaded.length) {
          this.offlineWorklogDrafts = this.offlineWorklogDrafts.filter((draft) => !uploaded.includes(draft.id));
          this.persistOfflineWorklogDrafts();
        }

        this.isUploadingOfflineWorklog = false;

        if (hadSuccessfulUploads) {
          this.updateOrder();
        }
      },
      getUser() {
        if (!this.$isOnline) {
          return;
        }
        axios
          .get("https://api.eines-as.no/users/me")
          .then((res) => {
            this.user = res.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      async getOrder() {
        // Guard against missing id prop
        if (!this.id) {
          console.warn('Order ID is not available yet');
          return;
        }

        if (!this.$isOnline) {
          const snapshot = this.loadOfflineOrderSnapshot();
          if (snapshot) {
            if (!this.order || this.order.id !== snapshot.id || this.offlineOrderUnavailable) {
              this.applyLoadedOrder(snapshot);
            }
          } else {
            this.offlineOrderUnavailable = true;
          }
          return;
        }

        try {
          const response = await axios.get(`https://api.eines-as.no/orders/${this.id}`);
          this.applyLoadedOrder(response.data);
          this.persistOfflineOrderSnapshot(response.data);
        } catch (error) {
          console.log(error);
        }
      },
      updateOrder() {
        if (!this.$isOnline) {
          return;
        }
        this.showEditDetails = false;

        // Send order confirmation
        if (this.order.send_confirmation == true) {
          this.order.send_confirmation = false;

          var message = {
              to: this.order.contact_email1, 
              subject: 'Ordrebekreftelse fra ' + this.order.supplier_company.name,
              template: '60462ff735f1aa48189844e4',
              supplier: this.order.supplier_company.name,
              customer: this.order.customer_company.name,
              details: {
                order: this.order,
                ordernumber: this.order.ordernumber,
                ordertype: this.order.type,
                url: 'https://www.aquaservices.no/#/customer/order-view/' + this.order.id,

              }
            };

            
          if (this.order.created_email != null) {
            message.cc = this.order.created_email
          }


          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {
              this.order.send_confirmation = false;
            })
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Send inovice notification

        if (this.order.status == "Til fakturering" && this.order.invoice_status == "Utkast") {
          this.order.invoice_status = "Sendt epost"

          var message = {
              to: this.order.supplier_company.invoice_accountant,
              subject: "Ordre er klar til fakturering",
              template: '60af9e32890f4e001570a71c',
              supplier: this.order.supplier_company.name,
              customer: this.order.customer_company.name,
              details: {
                order: this.order,
                ordernumber: this.order.ordernumber,
                ordertype: this.order.type,
                url: 'https://www.aquaservices.no/#/dashboard/order-edit/' + this.order.id,

              }
            };
          
          if (this.order.supplier_company.invoice_accountant2 != null) {
            message.cc = this.order.supplier_company.invoice_accountant2
          }

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Change order status if invoice is completed
        if (this.order.invoice_status == "Fakturert") {
          this.order.status = "Fakturert"
        }

        // Update order
        axios
          .put("https://api.eines-as.no/orders/" + this.order.id, this.order)
          .then((response) => {
            this.applyLoadedOrder(response.data);
            this.persistOfflineOrderSnapshot(response.data);
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      saveOrder() {
        if (!this.$isOnline) {
          return;
        }

        // Send order confirmation

        if (this.order.send_confirmation == true) {
          this.order.send_confirmation = false;
        
        var message = {
              to: this.order.contact_email1, 
              subject: 'Ordrebekreftelse fra ' + this.order.supplier_company.name,
              template: '60462ff735f1aa48189844e4',
              supplier: this.order.supplier_company.name,
              customer: this.order.customer_company.name,
              details: {
                order: this.order,
                ordernumber: this.order.ordernumber,
                ordertype: this.order.type,
                url: 'https://www.aquaservices.no/#/customer/order-view/' + this.order.id,

              }
            };

          if (this.order.created_email != null) {
            message.cc = this.order.created_email
          }

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {
              this.order.send_confirmation = false;
            })
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Send inovice notification

        if (this.order.status == "Til fakturering" && this.order.invoice_status == "Utkast") {
          this.order.invoice_status = "Sendt epost"

          var message = {
              to: this.order.supplier_company.invoice_accountant,
              subject: "Ordre er klar til fakturering",
              template: '60af9e32890f4e001570a71c',
              supplier: this.order.supplier_company.name,
              customer: this.order.customer_company.name,
              details: {
                order: this.order,
                ordernumber: this.order.ordernumber,
                ordertype: this.order.type,
                url: 'https://www.aquaservices.no/#/dashboard/order-edit/' + this.order.id,

              }
            };

          if (this.order.supplier_company.invoice_accountant2 != null) {
            message.cc = this.order.supplier_company.invoice_accountant2
          }

          axios
            .post("https://api.eines-as.no/messages", message)
            .then((response) => {})
            .catch(function (error) {
              console.log(error);
              this.isLoading = false;
            });
        }

        // Change order status if invoice is completed
        if (this.order.invoice_status == "Fakturert") {
          this.order.status = "Fakturert"
        }

        // Save order and go back to orders

        axios
          .put("https://api.eines-as.no/orders/" + this.order.id, this.order)
          .then((response) => {
            this.isLoading = false;
            this.$router.push("/dashboard/orders");
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      archiveOrder() {
        this.isLoading = true;

        this.order.archived = true

        axios
          .put("https://api.eines-as.no/orders/" + this.order.id, this.order)
          .then((response) => {
            this.isLoading = false;
            this.$router.push("/dashboard/orders");
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });

      },
      getVessels() {
        if (!this.$isOnline) {
          return Promise.resolve();
        }
        const company = localStorage.getItem("company");
        return axios
          .get(`https://api.eines-as.no/vessels?_where[company]=${company}`)
          .then((response) => {
            // build the options array
            this.vesselSelect = response.data.map(v => ({
              value: v,
              text:  v.name
            }));

            // if we already have an order.vessel, pick the matching option object
            if (this.order.vessel && this.order.vessel.id) {
              const match = this.vesselSelect.find(
                opt => opt.value.id === this.order.vessel.id
              );
              if (match) this.vessel = match.value;
            }
          });
      },
      getCaptain() {
        if (!this.$isOnline) {
          return Promise.resolve();
        }
        const company = localStorage.getItem("company");
        return axios
          .get(`https://api.eines-as.no/crews?_where[company]=${company}`)
          .then((response) => {
            this.captainSelect = response.data.map(c => ({
              value: c,
              text:  c.name
            }));

            if (this.order.captain && this.order.captain.id) {
              const match = this.captainSelect.find(
                opt => opt.value.id === this.order.captain.id
              );
              if (match) this.captain = match.value;
            }
          });
      },
      getLicecount() {
        if (!this.isOnline) {
          return;
        }
        this.isLoading = true;

        axios
          .get("https://api.eines-as.no/licecounts?_sort=createdAt:DESC&_where[order]=" + this.order.id)
          .then((res) => {
            this.licecount = res.data; 
            this.isLoading = false;
          });
      },
      async saveWorklog() {
        this.isLoading = true;

        const site = this.order.site || {};
        const customerCompany = this.order.customer_company || {};
        const supplierCompany = this.order.supplier_company || {};

        const from = moment(
          this.worklog.startdate + ", " + this.worklog.fromtime
        ).locale("no");

        const to = moment(
          this.worklog.enddate + ", " + this.worklog.totime
        ).locale("no");

        const worklogData = {
          action: this.worklog.action,
          billable: this.worklog.billable,
          billtype: this.worklog.billtype,
          rate: this.worklog.rate,
          total: this.worklog.total,
          from: from.toISOString(),
          to: to.toISOString(),
          duration: this.worklog.duration,
          description: this.worklog.description,
          order: this.order.id,
          ordernumber: this.order.ordernumber,
          site: site.name,
          number: site.number,
          customer: customerCompany.name,
          company: supplierCompany.id,
        };

        if (this.isOnline) {
          try {
            const response = await axios.post("https://api.eines-as.no/worklogs/", worklogData);
            this.order.worklogs.push(response.data);
            this.updateOrder();
            this.isLoading = false;
          } catch (error) {
            console.log(error);
            this.isLoading = false;
          }
        } else {
          this.saveWorklogDraft(worklogData);
          this.isLoading = false;
          this.syncOfflineFlags();
        }

      },
      updateWorklog() {
        var UpdateWorklogData = {
          action: this.editworklog.action,
          billable: this.editworklog.billable,
          billtype: this.editworklog.billtype,
          rate: this.editworklog.rate,
          total: this.editworklog.total,
          from: moment(
            this.editworklog.startdate + ", " + this.editworklog.fromtime
          ).locale("no"),
          to: moment(
            this.editworklog.enddate + ", " + this.editworklog.totime
          ).locale("no"),
          duration: this.editworklog.duration,
          description: this.editworklog.description,
          order: this.order.id,
          ordernumber: this.order.ordernumber,
          site: this.order.site.name,
          number: this.order.site.number,
          customer: this.order.customer_company.name,
          company: this.order.supplier_company.id,
        };

        if (!this.isOnline) {
          return;
        }

        axios
          .put(
            "https://api.eines-as.no/worklogs/" + this.editworklog.id,
            UpdateWorklogData
          )
          .then(() => {
            this.$bvModal.hide("editWorklogModal");
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      deleteWorklog() {
        if (!this.isOnline) {
          return;
        }
        this.order.invoice_hours =
          this.order.invoice_hours - this.editworklog.total;

        this.calculateInvoice();

        axios
          .delete("https://api.eines-as.no/worklogs/" + this.editworklog.id)
          .then(() => {
            this.$bvModal.hide("editWorklogModal");
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      customDateFormatter(date) {
      if (!date) return ''
      return moment(date).format('DD.MM.YYYY')
    },
    customFormatter(date) {
      return moment(date).format('DD.MM.YYYY HH:mm')
    },
    emptyTrip() {
      return {
        header: {
          captain: '',
          vessel: '',
          vesselTel: '',
          yearWeek: '',
          tripNumber: '',
          email: '',
          assignment: '',
          supplier: '',
          supplierTel: '',
          contactPerson: '',
          consessionNr: '',
          location: '',
          departurePort: '',
          tripStart: null
        },
        loading: {
          supplierVessel: '',
          method: '',
          arrivalDate: null,
          arrivalTime: null,
          plannedArrivalDate: null,
          plannedArrivalTime: null,
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          sumMerdsCount: null,
          sumMerdsWeight: null,
          avgWeight: null,
          starveDate: null,
          starveDuration: '',
          oxygenArrival: '',
          vetControl: false,
          loadingDuration: '',
          restriction: '',
          remarks: '',
          sumAllCages: { count: null, weight: null, avg: null },
          distributionBB: null,
          distributionSTB: null,
          oxygenDeparture: null,
          remarksLoading: '',
          signature: '',
        },
        cages: [],
        travel: {
          recordedDate: null,
          recordedTime: null,
          remarks: ''
        },
        unloading: {
          arrivalDate: null,
          arrivalTime: null,
          startDate: null,
          startTime: null,
          endDate: null,
          endTime: null,
          deadFishCount: null,
          seaTemperature: '',
          fishBehaviour: '',
          cages: '',
          remarksUnloading: '',
          sumMerdsCount: null,
          sumMerdsWeight: null,
          avgWeight: null,
        },
        unloadingCages: [],
        signatures: {
          crew: '',
          receiver: ''
        }
      }
    },
    openTripModal(mode, trip) {
      this.isEditing = mode === 'edit';
      this.tripModalTitle = this.isEditing ? 'Rediger rapport' : 'Ny rapport';

      if (this.isEditing && trip) {
        this.trip = JSON.parse(JSON.stringify(trip));
        
        // Ensure unloadingCages array exists for existing trips
        if (!this.trip.unloadingCages) {
          this.trip.unloadingCages = [];
        }
        
        // Recalculate unloading summary if cages exist
        if (this.trip.unloadingCages.length > 0) {
          this.updateUnloadingCageSummary();
        }
      } else {
        this.trip = this.emptyTrip();
        this.prefilltrip();
      }
      this.$bvModal.show('tripModal');
    },
    openTripPDF(trip) {
      this.trip = trip;
      this.$bvModal.show('tripPDFModal');
    },
    downloadTripPDF() {
      this.$refs.tripHtml2Pdf.generatePdf();
    },
    saveTripAttachment() {
      if (!this.isOnline) return;
      
      this.isLoading = true;
      const formData = new FormData();

      formData.append('ref', 'orders');
      formData.append('path', 'orders/' + this.order.id);
      formData.append('refId', this.order.id);
      formData.append('field', 'attachments');
      formData.append("files", this.selectedFile, this.selectedFile.name);
      formData.append('files', this.tripAttachment, this.tripAttachment.name);


        let optionsUpload = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }

        axios.post('https://api.eines-as.no/upload', formData, optionsUpload, )
        .then((response) => {
          this.trip.attachments.push(response.data);
          this.isLoading = false;
          this.$bvModal.hide('tripAttachmentModal');
          this.$bvToast && this.$bvToast.toast('Vedlegg lagret', { variant: 'success' });
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
          this.$bvToast && this.$bvToast.toast('Kunne ikke lagre vedlegg', { variant: 'danger' });
        });

          
    },
    saveTrip() {
      // Ensure the trip is linked to the order
      this.trip.order = this.order.id;
      this.trip.ordernumber = this.order.ordernumber;

      if (!this.isOnline) {
        return;
      }

      console.log('Saving trip with unloadingCages:', this.trip.unloadingCages);

      // Update existing trip
      if (this.isEditing && this.trip.id) {
       
        axios
          .put(`https://api.eines-as.no/trips/${this.trip.id}`, this.trip)
          .then((response) => {
            console.log('Trip saved, server response:', response.data);
            const updatedTrip = response.data;
            
            // Preserve unloadingCages if server doesn't return it
            if (!updatedTrip.unloadingCages && this.trip.unloadingCages) {
              updatedTrip.unloadingCages = this.trip.unloadingCages;
            }
            
            const index = this.order.trips.findIndex(trip => trip.id === updatedTrip.id);
            if (index !== -1) {
              this.order.trips.splice(index, 1, updatedTrip);
            }
            this.updateOrder();
            this.$bvModal.hide('tripModal');
            this.$bvToast && this.$bvToast.toast('Tur oppdatert', { variant: 'success' });
          })
          .catch((error) => {
            console.error(error);
            this.$bvToast && this.$bvToast.toast('Kunne ikke oppdatere tur', { variant: 'danger' });
          });
        return;
      }
      else if (!this.isEditing && this.trip.id == null) {
          // Create new trip
          this.trip.id = null; // Ensure the ID is null for new trip creation
          this.trip.ordernumber = this.order.ordernumber;
          this.isLoading = true;
          
          axios.post("https://api.eines-as.no/trips", this.trip)
          .then((response) => {
            console.log('New trip saved, server response:', response.data);
            const newTrip = response.data;
            
            // Preserve unloadingCages if server doesn't return it
            if (!newTrip.unloadingCages && this.trip.unloadingCages) {
              newTrip.unloadingCages = this.trip.unloadingCages;
            }
            
            this.order.trips.push(newTrip);
            this.updateOrder();

            this.$bvModal.hide('tripModal');
            this.$bvToast && this.$bvToast.toast('Tur lagret', { variant: 'success' });

            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      }
      else {
        this.$bvToast && this.$bvToast.toast('Ingen endringer å lagre', { variant: 'warning' });
      }

      this.resetTripForm();

    },
    deleteTrip() {
      if (!this.trip.id) return;
      if (!this.isOnline) {
        return;
      }
      this.$bvModal.msgBoxConfirm('Er du sikker på at du vil slette denne turen?', {
        title: 'Slett tur',
        okTitle: 'Ja, slett',
        cancelTitle: 'Avbryt',
        centered: true,
        okVariant: 'danger'
      }).then(confirmed => {
        if (confirmed) {
          this.isLoading = true;
          axios
            .delete(`https://api.eines-as.no/trips/${this.trip.id}`)
            .then(() => {
              // Remove from local list
              const idx = this.order.trips.findIndex(t => t.id === this.trip.id);
              if (idx !== -1) this.order.trips.splice(idx, 1);
              this.$bvModal.hide('tripModal');
              this.$bvToast && this.$bvToast.toast('Tur slettet', { variant: 'success' });
              this.isLoading = false;
            })
            .catch((error) => {
              this.$bvToast && this.$bvToast.toast('Kunne ikke slette tur', { variant: 'danger' });
              this.isLoading = false;
              console.error(error);
            });
        }
      });
    },
    resetTripForm() {
      this.trip = this.emptyTrip();
      this.isEditing = false;
    },
    getTrips() {
      if (!this.isOnline) {
        return;
      }
      axios
        .get(`https://api.eines-as.no/trips?_where[order]=${this.order.id}`)
        .then((res) => {
          this.trips = res.data;
        });
    },
    prefilltrip() {
      this.isEditing = false
      this.tripModalTitle = 'Ny rapport'
      const now = moment()

      // tripNumber = "<orderNumber>-<count+1>"

      var next = this.order.trips.length + 1
      this.trip.header.tripNumber   = `${this.order.ordernumber}-${next}`
      this.trip.header.vessel       = this.order.vessel.name
      this.trip.header.captain      = this.order.captain.name
      this.trip.header.vesselTel    = this.order.vessel.telefon
      this.trip.header.yearWeek     = `${now.year()} ${now.isoWeek()}`;    
      this.trip.header.email        = this.order.vessel.email
      this.trip.header.assignment   = this.order.details.transport  // if that maps

      this.trip.header.supplier     = this.order.supplier_company.name
      this.trip.header.supplierTel  = this.order.supplier_company.telefon
      this.trip.header.contactPerson= this.order.supplier_company.contact

      // Customer
      this.trip.header.customer     = this.order.customer_company.name
      this.trip.header.customerTel  = this.order.contact_phone
      this.trip.header.customerEmail = this.order.contact_email1
      this.trip.header.customerName = this.order.contact_name

      this.trip.header.consessionNr = this.order.site.number
      this.trip.header.location     = this.order.site.name
      this.trip.header.departurePort= this.order.details.departure_port
   
      // default dates/times
      this.trip.header.tripStart    = now.format('YYYY-MM-DDTHH:mm')
      this.trip.loading.startDate   = now.format('YYYY-MM-DD')
      this.trip.loading.startTime   = now.format('HH:mm')
      this.trip.travel.recordedDate = now.format('YYYY-MM-DD')
      this.trip.travel.recordedTime = now.format('HH:mm')
    },
    updateCageSummary() {
    const cages = this.trip.cages || [];
    let sumCount = 0;
    let sumWeight = 0;
    let avgWeight = 0;

    // Distribution counters
    let bbWeight = 0;
    let midtWeight = 0;
    let stbWeight = 0;

    if (cages.length > 0) {
      sumCount = cages.reduce((n, c) => n + (Number(c.fishcount) || 0), 0);
      sumWeight = cages.reduce((n, c) => n + (Number(c.biomass) || 0), 0);
      avgWeight = sumCount > 0 ? sumWeight / sumCount : 0;

      // Calculate distribution by well
      cages.forEach(c => {
        if (c.well === 'BB') bbWeight += Number(c.biomass) || 0;
        if (c.well === 'Midt') midtWeight += Number(c.biomass) || 0;
        if (c.well === 'STB') stbWeight += Number(c.biomass) || 0;
      });
    }

    // Calculate percent distribution
    let bbPercent = 0, midtPercent = 0, stbPercent = 0;
    if (sumWeight > 0) {
      bbPercent = Math.round((bbWeight / sumWeight) * 100);
      midtPercent = Math.round((midtWeight / sumWeight) * 100);
      stbPercent = Math.round((stbWeight / sumWeight) * 100);
    }

    this.trip.loading.sumMerdsCount = sumCount.toFixed(0);
    this.trip.loading.sumMerdsWeight = sumWeight.toFixed(0);
    this.trip.loading.avgWeight = avgWeight.toFixed(2);

    // Set distribution in percent
    this.trip.loading.distributionBB = bbPercent;
    this.trip.loading.distributionMidt = midtPercent;
    this.trip.loading.distributionSTB = stbPercent;
  },

  addCageTrip() {
    this.cage.biomass = this.cage.fishcount * this.cage.averageweight;
    this.trip.cages.push(this.cage);
    this.cage = {};

    // Calculate biomass ordered
    if (this.trip.cages[0] != null) {
      this.trip.biomass_ordered = this.trip.cages.reduce(
        (n, { biomass }) => n + biomass,
        0
      );
      this.trip.biomass_total = this.trip.biomass_ordered;
    }

    if (this.trip.cages[0] == null) {
      this.trip.biomass_ordered = 0;
      this.trip.biomass_total = this.trip.biomass_ordered;
    }

    // Update summary
    this.updateCageSummary();
  },

  removeCageTrip(cage) {
    let index = this.trip.cages.indexOf(cage);
    this.trip.cages.splice(index, 1);
    this.cage = {};

    // Calculate biomass ordered
    if (this.trip.cages[0] != null) {
      this.trip.biomass_ordered = this.trip.cages.reduce(
        (n, { biomass }) => n + biomass,
        0
      );
      this.trip.biomass_total = this.trip.biomass_ordered;
    }

    if (this.trip.cages[0] == null) {
      this.trip.biomass_ordered = 0;
      this.trip.biomass_total = this.trip.biomass_ordered;
    }

    // Update summary
    this.updateCageSummary();
  },

  addUnloadingCage() {
    this.unloadingCage.biomass = this.unloadingCage.fishcount * this.unloadingCage.averageweight;
    
    if (!this.trip.unloadingCages) {
      this.trip.unloadingCages = [];
    }
    
    this.trip.unloadingCages.push(this.unloadingCage);
    this.unloadingCage = {};

    // Update unloading summary
    this.updateUnloadingCageSummary();
  },

  removeUnloadingCage(cage) {
    if (!this.trip.unloadingCages) {
      return;
    }
    
    let index = this.trip.unloadingCages.indexOf(cage);
    this.trip.unloadingCages.splice(index, 1);
    this.unloadingCage = {};

    // Update unloading summary
    this.updateUnloadingCageSummary();
  },

  updateUnloadingCageSummary() {
    if (!this.trip.unloadingCages || this.trip.unloadingCages.length === 0) {
      this.trip.unloading.sumMerdsCount = null;
      this.trip.unloading.sumMerdsWeight = null;
      this.trip.unloading.avgWeight = null;
      return;
    }

    // Calculate totals
    const totalCount = this.trip.unloadingCages.reduce((sum, cage) => sum + (cage.fishcount || 0), 0);
    const totalWeight = this.trip.unloadingCages.reduce((sum, cage) => sum + (cage.biomass || 0), 0);
    const avgWeight = totalCount > 0 ? totalWeight / totalCount : 0;

    this.trip.unloading.sumMerdsCount = totalCount;
    this.trip.unloading.sumMerdsWeight = parseFloat(totalWeight.toFixed(0));
    this.trip.unloading.avgWeight = parseFloat(avgWeight.toFixed(2));
  },

  addCageFlush() {
        this.trip.cages.push(this.cage);
        this.cage = {};
  },
  updateYearWeekFromTripStart() {
      if (this.trip.header.tripStart) {
        const d = dayjs(this.trip.header.tripStart);
        if (d.isValid()) {
          this.trip.header.yearWeek = `${d.year()} / ${d.isoWeek()}`;
        }
      }
  },
  async saveFLS() {
      this.isLoading = true;

      this.fls_lastupdate = new Date();
      this.fls_settingsupdate = new Date();

      const site = this.order.site || {};
      const vessel = this.order.vessel || {};
      const customerCompany = this.order.customer_company || {};
      const supplierCompany = this.order.supplier_company || {};
      const flsMetrics = this.fls.data || {};

      const flsData = {
        order: this.order.id,
        ordernumber: this.order.ordernumber,
        site: site.name,
        number: site.number,
        vessel: vessel.name,
        customer: customerCompany.name,
        company: supplierCompany.id,
        lat: this.fls.lat,
        lng: this.fls.lng,
        lines: this.fls.lines,
        from_cage: this.fls.from_cage,
        to_cage: this.fls.to_cage,
        regtime: new Date(),
        comment: this.fls.comment,
        temperature_air: this.fls.temperature_air,
        temperature_sea: this.fls.temperature_sea,
        fishcount: this.fls.fishcount,
        biomass: this.fls.biomass,
        completed: this.fls.completed,
        data: {
          line1_ejector: flsMetrics.line1_ejector,
          line2_ejector: flsMetrics.line2_ejector,
          line3_ejector: flsMetrics.line3_ejector,
          line4_ejector: flsMetrics.line4_ejector,
          line1_extrasuction: flsMetrics.line1_extrasuction,
          line2_extrasuction: flsMetrics.line2_extrasuction,
          line3_extrasuction: flsMetrics.line3_extrasuction,
          line4_extrasuction: flsMetrics.line4_extrasuction,
          line1_flushpressure: flsMetrics.line1_flushpressure,
          line2_flushpressure: flsMetrics.line2_flushpressure,
          line3_flushpressure: flsMetrics.line3_flushpressure,
          line4_flushpressure: flsMetrics.line4_flushpressure,
          line1_oxygen: flsMetrics.line1_oxygen,
          line2_oxygen: flsMetrics.line2_oxygen,
          line3_oxygen: flsMetrics.line3_oxygen,
          line4_oxygen: flsMetrics.line4_oxygen,
        },
      };

      if (this.isOnline) {
        try {
          const response = await axios.post("https://api.eines-as.no/fls/", flsData);
          this.order.fls.push(response.data);
          this.isLoading = false;
          this.updateOrder();
        } catch (error) {
          console.log(error);
          this.isLoading = false;
        }
      } else {
        this.saveFlsDraft(flsData);
        this.isLoading = false;
        this.syncOfflineFlags();
      }

    },
    updateFLS() {
        if (!this.isOnline) {
          return;
        }
        axios
          .put("https://api.eines-as.no/fls/" + this.editfls.id, this.editfls)
          .then(() => {
            this.$bvModal.hide("editFLSModal");
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
    },
    deleteFLS() {
        if (!this.isOnline) {
          return;
        }
        axios
          .delete("https://api.eines-as.no/fls/" + this.editfls.id)
          .then(() => {
            this.$bvModal.hide("editFLSModal");
            this.updateOrder();
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
    },
    getFLSBiomass() {
        this.order.details.biomass_total = this.flsSumBiomass
        this.$forceUpdate();

    },
    saveDeclaration() {
        if (!this.isOnline) {
          return;
        }
        this.isLoading = true;

        var declarationData = {
          orderid: this.order.id,
          ordernumber: this.order.ordernumber,
          site: this.order.site.name,
          number: this.order.site.number,
          vessel: this.order.vessel.name,
          maintenance_date: this.order.vessel.maintenance_date,
          maintenance_site: this.order.vessel.maintenance_site,
          customer: this.order.customer_company.name,
          company: this.order.supplier_company.id,
          details: this.declaration.details,
          accepted_date: this.declaration.accepted_date,
          completed_date: this.declaration.completed_date,
          accepted_by: this.declaration.accepted_by,
          note: this.declaration.note,
        };

        axios
          .post("https://api.eines-as.no/declarations/", declarationData)
          .then((response) => {
            this.order.declarations.push(response.data);
            this.updateOrder();
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }, 
      getFactories() {
        if (!this.isOnline) {
          return;
        }
        axios
          .get("https://api.eines-as.no/factories")
          .then((res) => {
            this.factories = res.data;
          });
      },
      onUpload() {
        if (!this.isOnline) {
          return;
        }
        this.isLoading = true;
        let formData = new FormData()

        formData.append('ref', 'orders');
        formData.append('path', 'orders/' + this.order.id);
        formData.append('refId', this.order.id);
        formData.append('field', 'attachments');
        formData.append("files", this.selectedFile, this.selectedFile.name);

        let optionsUpload = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }

        axios.post('https://api.eines-as.no/upload', formData, optionsUpload, )
          .then((response) => {
            this.selectedFile = null
            this.getOrder()
            this.isLoading = false;
          })

      },
      deleteUpload(attachment) {
        if (!this.isOnline) {
          return;
        }
        this.isLoading = true;
        console.log(attachment)

          this.order.attachments.splice( this.order.attachments.findIndex(function(attachment){
                return attachment.id === attachment.id;
          }), 1);
        
        axios.delete('https://api.eines-as.no/upload/files/' + attachment.id )

        this.isLoading = false

      },
      onFileChanged(event) {
        this.selectedFile = event.target.files[0]
      },
      addCage() {
        this.cage.fishcount = this.cage.biomass / this.cage.averageweight;
        this.order.details.cages.push(this.cage);
        this.cage = {};
        this.updateOrder();
      },
      removeCage(cage) {
        let index = this.order.details.cages.indexOf(cage);
        this.order.details.cages.splice(index, 1);
        this.updateOrder();
      },
      generateReport() {
        this.isLoading = true;
        this.$refs.html2Pdf.generatePdf();
        this.isLoading = false;
      },
      editWorklogModal(worklog) {
        this.editworklog = worklog;
        this.editworklog.startdate = moment(worklog.from).format("YYYY-MM-DD");

        this.editworklog.enddate = moment(worklog.to).format("YYYY-MM-DD");

        this.editworklog.fromtime = moment(worklog.from).format("HH:mm");

        this.editworklog.totime = moment(worklog.to).format("HH:mm");
        this.$bvModal.show("editWorklogModal");
      },
      closeWorklogModal() {
        this.$bvModal.hide("editWorklogModal");
      },
      editFLSModal(fls) {
        this.editfls = fls;
        this.$bvModal.show("editFLSModal");
      },
      closeFLSModal() {
        this.$bvModal.hide("editFLSModal");
      },
      openModalArchive() {
        this.$bvModal.show("archiveModal");
      },
      closeModalArchive() {
        this.$bvModal.hide("archiveModal");
      },
      openModalData() {
        this.$bvModal.show("dataModal");
      },
      closeModalData() {
        this.$bvModal.hide("dataModal");
      },
      getFLSsettings() {
        this.fls = this.order.settings;
      },
      saveFLSsettings() {
        this.order.settings = this.fls;
        this.updateOrder();
      },
      saveLog(logdata) {
        if (!this.isOnline) {
          return;
        }
        this.isLoading = true;

        var logData = {
          type: "FLS",
          data: logdata,
          from: order.company_supplier.id,
        };

        axios
          .post("https://api.eines-as.no/logs/", logData)
          .then((response) => {
            this.order.worklogs.push(response.data);
            this.updateOrder();
            this.isLoading = false;
          })
          .catch(function (error) {
            console.log(error);
            this.isLoading = false;
          });
      },
      editLicecount(licecountId) {
        this.$router.push("/dashboard/licecount-edit/" + licecountId);
      },
      changeWorklogAction(action) {
        this.worklog.rate = action.rate;
        this.worklog.billable = action.billable;
        this.calculateWorklogDuration();
      },
      changeEditWorklogAction(action) {
        this.editworklog.rate = action.rate;
        this.editworklog.billable = action.billable;
        this.calculateEditWorklogDuration();
      },
      calculateWorklogDuration() {
        this.worklog.duration = null;
        this.$forceUpdate();

        var start = moment(
          this.worklog.startdate + ", " + this.worklog.fromtime
        ).locale("no");

        var end = moment(
          this.worklog.enddate + ", " + this.worklog.totime
        ).locale("no");

        var durationWorklog = moment(end).diff(start, "minutes") / 60;

        var durationWorklogCal = Math.round(durationWorklog / 0.5) * 0.5;

        this.worklog.duration = durationWorklogCal;

        this.worklog.total = this.worklog.duration * this.worklog.rate;
      },
      calculateEditWorklogDuration() {

        this.editworklog.duration = null;
        this.$forceUpdate();

        var start = moment(
          this.editworklog.startdate + ", " + this.editworklog.fromtime
        ).locale("no");

        var end = moment(
          this.editworklog.enddate + ", " + this.editworklog.totime
        ).locale("no");

        var durationWorklog = moment(end).diff(start, "minutes") / 60;

        var durationWorklogCal = Math.round(durationWorklog / 0.5) * 0.5;

        if (this.editworklog.billtype == 'Timepris') {

           this.editworklog.duration = durationWorklogCal;
            this.editworklog.total =
            this.editworklog.duration * this.editworklog.rate;

        }

      },
      calculateInvoice() {
        this.showEditDetails = false;
        this.$forceUpdate();

        // Calculate worklog total billable hours

        if (this.order.worklogs[0] != null) {
          this.worklogSumHoursBillable = this.order.worklogs
            .filter(({
              billable
            }) => billable == true)
            .reduce((n, {
              duration
            }) => n + duration, 0);
        }

        if (this.order.agreement_type == "Pris pr. kg") {
          this.order.invoice_biomass =
            this.order.details.biomass_total * this.order.agreement_price;

          this.order.invoice_total =
            this.order.invoice_hours + this.order.invoice_biomass
        }

        if (
          this.order.agreement_type == "Avtale" ||
          this.order.agreement_type == "Fastpris"
        ) {
          this.order.invoice_total =
            this.order.invoice_hours + parseInt(this.order.invoice_fixedprice)
        }
      },
      lookupCompanies: debounce(function () {
        // in practice this action should be debounced
        if (!this.isOnline) {
          return;
        }

        axios
          .get(
            `https://api.eines-as.no/companies?_where[type]=Customer&_q=${this.queryCompany}`
          )
          .then((response) => {
            this.companies = response.data;
          });
      }, 250),
      lookupFactories: debounce(function () {
        // in practice this action should be debounced
        if (!this.isOnline) {
          return;
        }

        axios
          .get(
            `https://api.eines-as.no/factories?_q=${this.queryFactories}`
          )
          .then((response) => {
            this.factories = response.data;
          });
      }, 100),
      lookupSites: debounce(function () {
        // in practice this action should be debounced
        if (!this.isOnline) {
          return;
        }

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySites}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 100),
      lookupSitesTransport: debounce(function () {
        // in practice this action should be debounced
        if (!this.isOnline) {
          return;
        }

        axios
          .get(`https://api.eines-as.no/sites?_q=${this.querySitesTransport}`)
          .then((response) => {
            this.sites = response.data;
          });
      }, 100),
      externalLink(url) {
        window.open(url, "_blank");
      },
      goExternalPage() {
        window.open(
          "https://www.ordertracker.com/sscc/" +
          this.order.sscc +
          "?number=" +
          this.order.number +
          "&type=1",
          "_blank"
        );
      },
      editContact() {
        this.showContacts = true;
      },
      saveContact() {
        this.showContacts = false;
        this.updateOrder();
      },
      editDetails() {
        this.showEditDetails = true;
      },
      saveDetails() {
        this.calculateInvoice();

        this.updateOrder();
      },
      rowLicecount(item, type) {
        if (!item || type !== "row") return;
        if (item.type == "Ut telling") return "table-success";
      },
      rowCompleted(item, type) {
        if (!item || type !== "row") return;
        if (item.completed == true) return "table-success";
      },
      refreshMap() {
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 250);
      },
      customFormatter(date) {
        return moment(date).format("DD.MM.YYYY");
      },
      getDates() {
        this.worklog.startdate = dayjs().format("YYYY-MM-DD");
        this.worklog.enddate = dayjs().format("YYYY-MM-DD");
        this.worklog.fromtime = dayjs().format("HH:mm");
        this.worklog.totime = dayjs().format("HH:mm");
        this.declaration.accepted_date = new Date();
        this.declaration.completed_date = new Date();
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() + 5); 
      },
      goBack() {
        this.$router.push("/dashboard/orders");
      },
      refreshMap() {
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 0);
      },
      setQuerySites() {
        if (this.order.site) {
          this.querySites = this.order.site.number + ' - ' + this.order.site.name;
        }
      },
      setQuerySitesTransport() {
        if (this.order.details && this.order.details.destination) {
          this.querySitesTransport = this.order.details.destination.number + ' - ' + this.order.details.destination.name;
        }
      },
    },
    created: function () {
      this.syncOfflineFlags();
      if (this.$isOnline) {
        this.getUser();
        this.getFactories();
      }
      this.getOrder();
      this.getDates();
      //this.getTrips();
      this.setQuerySites();
      this.setQuerySitesTransport();
    },
  };

</script>

<style lang="css">
  @import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";

  .overflow-hidden {
    overflow-x: hidden !important;
    overflow-y: hidden !important;
  }

  .flscellmaxwidth {
    max-width: 250px;
  }

  .worklogmaxwidth {
    max-width: 300px;
  }

  .notemaxwidth {
    max-width: 300px;
  }

  .report-company-logo {
    max-width: 250px;
  }

  .h-scroll {
    height: 80vh;
    /* %-height of the viewport */
    overflow: auto;
  }

  .dot {
    text-align: center;
    height: 7px;
    width: 7px;
    background-color: #801529;
    border-radius: 50%;
    display: inline-block;
  }

  label {
    display: block;
    width: x;
    height: y;
    text-align: left;
  }

  .table .table-success,
  .table .table-success>th,
  .table .table-success>td {
    background-color: #e4fae9;
  }

  /* Timeline */

ul.timeline {
  list-style-type: none;
  position: relative;
}

ul.timeline:before {
  content: " ";
  background: #d4d9df;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}

ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.timeline > li:before {
  content: " ";
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 3px solid #022d56;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}

.table .table-success,
.table .table-success > th,
.table .table-success > td {
  background-color: #e4fae9;
}


  @media (min-width: 576px) {
    .card-columns {
      column-count: 1;
    }

    .card-columns-nomap {
      column-count: 1 !important;
    }
  }

  @media (min-width: 768px) {
    .card-columns {
      column-count: 1;
    }

    .card-columns-nomap {
      column-count: 1 !important;
    }
  }

  @media (min-width: 1024px) {
    .card-columns {
      column-count: 2;
    }

    .card-columns-nomap {
      column-count: 2 !important;
    }
  }

  @media (min-width: 1250px) {
    .card-columns {
      column-count: 2;
    }

    .card-columns-nomap {
      column-count: 2 !important;
    }
  }


  .section-break {
    page-break-before: always;
  }


  .pdf-document {
  padding: 0.5cm 0.5cm 0.5cm 0.5cm;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #333;
}

.pdf-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}
.pdf-header .logo {
  max-height: 40px;
  max-width: 100%; /* Changed from auto to 100% */
}
.pdf-header .order-info h2 {
  margin: 0;
  font-size: 1.4rem;
}
.pdf-header .order-info p {
  margin: 0.2rem 0;
  font-size: 0.9rem;
}

.section-title {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.1rem;
  border-bottom: 1px solid #bbb;
  padding-bottom: 0.2rem;
}

.summary-table,
.info-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1rem;
}

.summary-table th,
.summary-table td {
  border: 1px solid #ddd;
  padding: 0.4rem 0.6rem;
  font-size: 0.9rem;
}
.summary-table th {
  background: #f4f4f4;
  text-align: left;
}

.info-table .label {
  font-weight: 600;
  width: 15%;
  vertical-align: top;
  padding: 0.3rem 0.6rem;
}
.info-table td {
  padding: 0.3rem 0.6rem;
  font-size: 0.9rem;
}

.declaration-section ol {
  margin: 0.5rem 1rem;
  padding-left: 1rem;
}
.declaration-section li {
  margin-bottom: 0.5rem;
}
.declaration-section small {
  display: block;
  margin-top: 0.2rem;
  color: #555;
  font-size: 0.85rem;
}

.declaration-completion p {
  margin: 0.4rem 0;
  font-size: 0.9rem;
}

.pdf-table th,
.pdf-table td {
  font-size: 0.85rem;
  padding: 0.3rem 0.5rem;
}


</style>
